package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Zambia Flag (32x24dp)
 *
 * - ISO Alpha-2: ZM
 * - ISO Alpha-3: ZMB
 * - ISO Numeric: 894
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Zambia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Zambia:ZM:ZMB:894:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFF8126))) {
                moveTo(27f, 10f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-5f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(22f, 10f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-5f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(17f, 10f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF8126)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(24.547f, 4.838f)
                curveTo(25.028f, 4.987f, 24.547f, 5.215f, 24.547f, 5.215f)
                curveTo(24.547f, 5.215f, 24.452f, 5.122f, 24.452f, 5.044f)
                curveTo(24.452f, 4.967f, 24.083f, 5.044f, 23.893f, 5.327f)
                curveTo(23.713f, 5.594f, 24.045f, 5.594f, 24.394f, 5.593f)
                curveTo(24.413f, 5.593f, 24.433f, 5.593f, 24.452f, 5.593f)
                curveTo(24.649f, 5.593f, 24.958f, 5.576f, 25.244f, 5.561f)
                curveTo(25.494f, 5.548f, 25.727f, 5.535f, 25.857f, 5.535f)
                curveTo(26.135f, 5.535f, 26.267f, 5.535f, 26.634f, 5.327f)
                curveTo(26.873f, 5.191f, 27.663f, 5.025f, 28.25f, 4.902f)
                curveTo(28.566f, 4.835f, 28.824f, 4.781f, 28.905f, 4.751f)
                curveTo(29.137f, 4.664f, 28.673f, 5.122f, 28.673f, 5.122f)
                curveTo(28.673f, 5.122f, 30.462f, 4.514f, 30.82f, 4.306f)
                curveTo(31.041f, 4.177f, 30.941f, 4.287f, 30.777f, 4.466f)
                curveTo(30.676f, 4.577f, 30.55f, 4.714f, 30.462f, 4.838f)
                curveTo(30.31f, 5.049f, 30.618f, 4.848f, 30.96f, 4.624f)
                curveTo(31.144f, 4.504f, 31.337f, 4.378f, 31.474f, 4.306f)
                curveTo(31.868f, 4.098f, 31.374f, 4.662f, 31.157f, 4.838f)
                curveTo(30.94f, 5.014f, 31.667f, 4.838f, 31.919f, 4.662f)
                curveTo(32.104f, 4.532f, 31.935f, 4.759f, 31.792f, 4.949f)
                curveTo(31.741f, 5.017f, 31.693f, 5.081f, 31.667f, 5.122f)
                lineTo(31.663f, 5.129f)
                curveTo(31.565f, 5.279f, 31.534f, 5.327f, 31.767f, 5.327f)
                curveTo(32.004f, 5.327f, 31.157f, 5.883f, 31.157f, 5.883f)
                curveTo(31.157f, 5.883f, 31.409f, 5.849f, 31.157f, 6.219f)
                curveTo(31.008f, 6.437f, 30.283f, 6.657f, 29.695f, 6.836f)
                curveTo(29.285f, 6.961f, 28.942f, 7.065f, 28.905f, 7.135f)
                curveTo(28.838f, 7.26f, 28.179f, 7.405f, 27.871f, 7.472f)
                curveTo(27.761f, 7.497f, 27.697f, 7.511f, 27.719f, 7.511f)
                curveTo(27.806f, 7.511f, 27.951f, 7.603f, 27.794f, 7.603f)
                curveTo(27.637f, 7.603f, 27.362f, 7.678f, 27.362f, 7.678f)
                curveTo(27.362f, 7.678f, 27.507f, 7.678f, 27.362f, 7.852f)
                curveTo(27.293f, 7.936f, 27.171f, 7.922f, 27.086f, 7.913f)
                curveTo(26.993f, 7.903f, 26.943f, 7.898f, 27.05f, 8.026f)
                curveTo(27.145f, 8.14f, 27.181f, 8.183f, 27.172f, 8.196f)
                curveTo(27.161f, 8.212f, 27.088f, 8.186f, 26.974f, 8.186f)
                curveTo(26.874f, 8.186f, 26.767f, 8.15f, 26.656f, 8.112f)
                curveTo(26.532f, 8.07f, 26.402f, 8.026f, 26.267f, 8.026f)
                curveTo(26.02f, 8.026f, 26.268f, 8.174f, 26.422f, 8.266f)
                curveTo(26.429f, 8.269f, 26.435f, 8.273f, 26.441f, 8.277f)
                curveTo(26.579f, 8.359f, 26.521f, 8.359f, 26.272f, 8.358f)
                curveTo(26.247f, 8.358f, 26.22f, 8.358f, 26.191f, 8.358f)
                curveTo(26.036f, 8.358f, 25.952f, 8.344f, 25.908f, 8.336f)
                curveTo(25.861f, 8.328f, 25.857f, 8.327f, 25.857f, 8.358f)
                curveTo(25.857f, 8.387f, 25.74f, 8.346f, 25.599f, 8.297f)
                curveTo(25.454f, 8.246f, 25.283f, 8.186f, 25.19f, 8.186f)
                curveTo(25.007f, 8.186f, 25.578f, 8.504f, 25.578f, 8.504f)
                curveTo(25.578f, 8.504f, 25.281f, 8.423f, 25.12f, 8.358f)
                curveTo(25.028f, 8.321f, 25.145f, 8.496f, 25.25f, 8.654f)
                curveTo(25.329f, 8.774f, 25.402f, 8.885f, 25.373f, 8.885f)
                curveTo(25.351f, 8.885f, 25.302f, 8.865f, 25.246f, 8.842f)
                curveTo(25.132f, 8.796f, 24.988f, 8.738f, 24.988f, 8.816f)
                curveTo(24.988f, 8.931f, 25.12f, 9.017f, 25.281f, 9.017f)
                curveTo(25.442f, 9.017f, 25.468f, 9.198f, 25.373f, 9.198f)
                curveTo(25.34f, 9.198f, 25.3f, 9.186f, 25.261f, 9.174f)
                curveTo(25.187f, 9.153f, 25.12f, 9.133f, 25.12f, 9.198f)
                curveTo(25.12f, 9.24f, 25.148f, 9.271f, 25.181f, 9.307f)
                curveTo(25.227f, 9.357f, 25.281f, 9.416f, 25.281f, 9.525f)
                curveTo(25.281f, 9.712f, 25.041f, 9.739f, 25.12f, 9.615f)
                curveTo(25.198f, 9.491f, 24.847f, 9.191f, 24.847f, 9.337f)
                verticalLineTo(9.525f)
                curveTo(24.847f, 9.657f, 24.817f, 9.666f, 24.77f, 9.679f)
                curveTo(24.741f, 9.687f, 24.705f, 9.697f, 24.666f, 9.739f)
                curveTo(24.608f, 9.801f, 24.599f, 9.837f, 24.594f, 9.857f)
                curveTo(24.59f, 9.876f, 24.588f, 9.881f, 24.547f, 9.881f)
                curveTo(24.514f, 9.881f, 24.486f, 9.839f, 24.45f, 9.784f)
                curveTo(24.393f, 9.698f, 24.314f, 9.579f, 24.159f, 9.525f)
                curveTo(24.012f, 9.473f, 24.004f, 9.511f, 23.991f, 9.576f)
                curveTo(23.981f, 9.623f, 23.968f, 9.686f, 23.893f, 9.739f)
                curveTo(23.781f, 9.818f, 23.812f, 9.851f, 23.849f, 9.89f)
                curveTo(23.87f, 9.913f, 23.893f, 9.937f, 23.893f, 9.973f)
                curveTo(23.893f, 10.073f, 23.697f, 9.874f, 23.697f, 9.739f)
                curveTo(23.697f, 9.604f, 23.474f, 9.425f, 23.474f, 9.525f)
                curveTo(23.474f, 9.624f, 23.474f, 9.739f, 23.36f, 9.739f)
                curveTo(23.305f, 9.739f, 23.302f, 9.772f, 23.3f, 9.817f)
                curveTo(23.297f, 9.865f, 23.293f, 9.926f, 23.221f, 9.973f)
                curveTo(23.15f, 10.02f, 23.152f, 9.995f, 23.155f, 9.94f)
                curveTo(23.158f, 9.888f, 23.163f, 9.809f, 23.108f, 9.739f)
                curveTo(23.039f, 9.651f, 23.097f, 9.516f, 23.126f, 9.447f)
                curveTo(23.145f, 9.403f, 23.152f, 9.386f, 23.108f, 9.425f)
                curveTo(22.997f, 9.525f, 22.855f, 9.525f, 22.759f, 9.525f)
                horizontalLineTo(22.755f)
                curveTo(22.707f, 9.525f, 22.665f, 9.577f, 22.635f, 9.614f)
                curveTo(22.605f, 9.65f, 22.587f, 9.672f, 22.587f, 9.615f)
                curveTo(22.587f, 9.5f, 22.729f, 9.198f, 22.997f, 9.198f)
                curveTo(23.203f, 9.198f, 23.307f, 9.127f, 23.396f, 9.067f)
                curveTo(23.423f, 9.049f, 23.448f, 9.031f, 23.474f, 9.017f)
                curveTo(23.589f, 8.955f, 23.474f, 8.875f, 23.36f, 8.816f)
                curveTo(23.308f, 8.789f, 23.326f, 8.702f, 23.363f, 8.624f)
                curveTo(23.426f, 8.59f, 23.474f, 8.547f, 23.474f, 8.504f)
                curveTo(23.474f, 8.451f, 23.406f, 8.531f, 23.363f, 8.624f)
                curveTo(23.28f, 8.669f, 23.172f, 8.7f, 23.108f, 8.7f)
                curveTo(23.047f, 8.7f, 23.085f, 8.607f, 23.133f, 8.49f)
                curveTo(23.174f, 8.391f, 23.221f, 8.276f, 23.221f, 8.186f)
                curveTo(23.221f, 8.101f, 23.238f, 8.026f, 23.25f, 7.975f)
                curveTo(23.265f, 7.908f, 23.271f, 7.88f, 23.221f, 7.916f)
                curveTo(23.159f, 7.96f, 22.828f, 7.911f, 22.602f, 7.878f)
                curveTo(22.505f, 7.864f, 22.427f, 7.852f, 22.399f, 7.852f)
                curveTo(22.357f, 7.852f, 22.391f, 7.785f, 22.424f, 7.719f)
                curveTo(22.467f, 7.635f, 22.509f, 7.552f, 22.399f, 7.603f)
                curveTo(22.226f, 7.684f, 21.874f, 7.681f, 21.651f, 7.679f)
                curveTo(21.619f, 7.678f, 21.589f, 7.678f, 21.563f, 7.678f)
                curveTo(21.433f, 7.678f, 21.523f, 7.581f, 21.57f, 7.529f)
                curveTo(21.598f, 7.5f, 21.612f, 7.485f, 21.563f, 7.511f)
                curveTo(21.431f, 7.582f, 21.299f, 7.603f, 21.149f, 7.603f)
                curveTo(21.082f, 7.603f, 21.063f, 7.57f, 21.042f, 7.533f)
                curveTo(21.016f, 7.488f, 20.987f, 7.438f, 20.866f, 7.439f)
                curveTo(20.645f, 7.441f, 20.596f, 7.438f, 20.474f, 7.357f)
                curveTo(20.411f, 7.315f, 20.446f, 7.29f, 20.466f, 7.276f)
                curveTo(20.485f, 7.263f, 20.491f, 7.259f, 20.394f, 7.259f)
                horizontalLineTo(19.794f)
                curveTo(19.496f, 7.259f, 19.795f, 7.063f, 19.903f, 7.063f)
                curveTo(20.01f, 7.063f, 20.135f, 6.886f, 19.903f, 6.965f)
                curveTo(19.754f, 7.016f, 19.595f, 7.002f, 19.407f, 6.985f)
                curveTo(19.301f, 6.976f, 19.186f, 6.965f, 19.059f, 6.965f)
                curveTo(18.704f, 6.965f, 18.636f, 6.827f, 18.846f, 6.827f)
                curveTo(19.055f, 6.827f, 19.068f, 6.726f, 18.742f, 6.726f)
                curveTo(18.538f, 6.726f, 18.37f, 6.679f, 18.245f, 6.644f)
                curveTo(18.171f, 6.624f, 18.111f, 6.607f, 18.069f, 6.607f)
                curveTo(17.954f, 6.607f, 17.83f, 6.471f, 18.069f, 6.471f)
                curveTo(18.308f, 6.471f, 18.614f, 6.358f, 18.353f, 6.358f)
                curveTo(18.205f, 6.358f, 17.958f, 6.291f, 17.744f, 6.234f)
                curveTo(17.579f, 6.189f, 17.433f, 6.15f, 17.365f, 6.15f)
                curveTo(17.313f, 6.15f, 17.394f, 6.135f, 17.502f, 6.116f)
                curveTo(17.718f, 6.077f, 18.04f, 6.018f, 17.629f, 6.018f)
                curveTo(17.19f, 6.018f, 16.73f, 5.716f, 16.413f, 5.508f)
                curveTo(16.284f, 5.423f, 16.178f, 5.354f, 16.107f, 5.327f)
                curveTo(15.861f, 5.232f, 16.107f, 5.044f, 16.178f, 5.122f)
                curveTo(16.249f, 5.2f, 16.746f, 5.32f, 16.531f, 5.215f)
                curveTo(16.315f, 5.111f, 16.178f, 4.934f, 16.107f, 4.838f)
                curveTo(16.036f, 4.742f, 16.091f, 4.675f, 16.178f, 4.751f)
                curveTo(16.265f, 4.827f, 16.668f, 5.044f, 16.668f, 5.044f)
                curveTo(16.668f, 5.044f, 16.452f, 4.838f, 16.281f, 4.514f)
                curveTo(16.11f, 4.19f, 16.452f, 4.269f, 16.746f, 4.514f)
                curveTo(17.039f, 4.759f, 17.314f, 4.824f, 17.452f, 4.838f)
                curveTo(17.59f, 4.852f, 17.314f, 4.661f, 17.048f, 4.514f)
                curveTo(16.782f, 4.366f, 16.843f, 3.838f, 17.048f, 4.049f)
                curveTo(17.155f, 4.159f, 17.661f, 4.368f, 18.156f, 4.572f)
                curveTo(18.613f, 4.761f, 19.06f, 4.945f, 19.176f, 5.044f)
                curveTo(19.376f, 5.216f, 19.215f, 4.96f, 19.04f, 4.683f)
                curveTo(19.004f, 4.626f, 18.968f, 4.569f, 18.934f, 4.514f)
                curveTo(18.818f, 4.325f, 19.284f, 4.539f, 19.814f, 4.783f)
                curveTo(20.196f, 4.958f, 20.611f, 5.149f, 20.866f, 5.215f)
                curveTo(21.042f, 5.261f, 21.251f, 5.335f, 21.461f, 5.408f)
                curveTo(21.978f, 5.59f, 22.494f, 5.77f, 22.494f, 5.535f)
                curveTo(22.494f, 5.205f, 22.967f, 4.688f, 23.474f, 4.514f)
                curveTo(23.796f, 4.403f, 23.948f, 4.503f, 24.138f, 4.629f)
                curveTo(24.248f, 4.702f, 24.371f, 4.783f, 24.547f, 4.838f)
                close()
                moveTo(24.001f, 8.714f)
                curveTo(24.116f, 8.714f, 24.084f, 7.71f, 24.084f, 7.71f)
                curveTo(24.084f, 7.71f, 24.422f, 8.326f, 24.422f, 8.592f)
                curveTo(24.422f, 8.713f, 24.412f, 8.749f, 24.415f, 8.784f)
                curveTo(24.419f, 8.826f, 24.442f, 8.866f, 24.524f, 9.049f)
                curveTo(24.607f, 9.234f, 24.552f, 9.214f, 24.401f, 9.159f)
                curveTo(24.28f, 9.115f, 24.097f, 9.049f, 23.875f, 9.049f)
                curveTo(23.377f, 9.049f, 23.887f, 8.714f, 24.001f, 8.714f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(24.547f, 5.215f)
                lineTo(24.459f, 5.305f)
                lineTo(24.522f, 5.366f)
                lineTo(24.601f, 5.328f)
                lineTo(24.547f, 5.215f)
                close()
                moveTo(24.547f, 4.838f)
                lineTo(24.584f, 4.718f)
                lineTo(24.547f, 4.838f)
                close()
                moveTo(23.893f, 5.327f)
                lineTo(23.789f, 5.257f)
                verticalLineTo(5.257f)
                lineTo(23.893f, 5.327f)
                close()
                moveTo(24.394f, 5.593f)
                lineTo(24.394f, 5.718f)
                lineTo(24.394f, 5.593f)
                close()
                moveTo(25.244f, 5.561f)
                lineTo(25.238f, 5.436f)
                lineTo(25.244f, 5.561f)
                close()
                moveTo(26.634f, 5.327f)
                lineTo(26.696f, 5.436f)
                lineTo(26.634f, 5.327f)
                close()
                moveTo(28.25f, 4.902f)
                lineTo(28.225f, 4.779f)
                lineTo(28.25f, 4.902f)
                close()
                moveTo(28.905f, 4.751f)
                lineTo(28.949f, 4.868f)
                verticalLineTo(4.868f)
                lineTo(28.905f, 4.751f)
                close()
                moveTo(28.673f, 5.122f)
                lineTo(28.585f, 5.033f)
                lineTo(28.713f, 5.241f)
                lineTo(28.673f, 5.122f)
                close()
                moveTo(30.82f, 4.306f)
                lineTo(30.757f, 4.198f)
                verticalLineTo(4.198f)
                lineTo(30.82f, 4.306f)
                close()
                moveTo(30.777f, 4.466f)
                lineTo(30.869f, 4.55f)
                lineTo(30.869f, 4.55f)
                lineTo(30.777f, 4.466f)
                close()
                moveTo(30.462f, 4.838f)
                lineTo(30.563f, 4.911f)
                verticalLineTo(4.911f)
                lineTo(30.462f, 4.838f)
                close()
                moveTo(30.96f, 4.624f)
                lineTo(31.029f, 4.729f)
                verticalLineTo(4.729f)
                lineTo(30.96f, 4.624f)
                close()
                moveTo(31.474f, 4.306f)
                lineTo(31.532f, 4.416f)
                verticalLineTo(4.416f)
                lineTo(31.474f, 4.306f)
                close()
                moveTo(31.157f, 4.838f)
                lineTo(31.078f, 4.741f)
                lineTo(31.157f, 4.838f)
                close()
                moveTo(31.919f, 4.662f)
                lineTo(31.847f, 4.559f)
                verticalLineTo(4.559f)
                lineTo(31.919f, 4.662f)
                close()
                moveTo(31.792f, 4.949f)
                lineTo(31.692f, 4.874f)
                lineTo(31.692f, 4.874f)
                lineTo(31.792f, 4.949f)
                close()
                moveTo(31.667f, 5.122f)
                lineTo(31.772f, 5.19f)
                lineTo(31.772f, 5.19f)
                lineTo(31.667f, 5.122f)
                close()
                moveTo(31.663f, 5.129f)
                lineTo(31.767f, 5.197f)
                lineTo(31.767f, 5.197f)
                lineTo(31.663f, 5.129f)
                close()
                moveTo(31.157f, 5.883f)
                lineTo(31.088f, 5.778f)
                lineTo(31.173f, 6.006f)
                lineTo(31.157f, 5.883f)
                close()
                moveTo(31.157f, 6.219f)
                lineTo(31.26f, 6.289f)
                verticalLineTo(6.289f)
                lineTo(31.157f, 6.219f)
                close()
                moveTo(29.695f, 6.836f)
                lineTo(29.659f, 6.717f)
                lineTo(29.695f, 6.836f)
                close()
                moveTo(28.905f, 7.135f)
                lineTo(28.795f, 7.076f)
                verticalLineTo(7.076f)
                lineTo(28.905f, 7.135f)
                close()
                moveTo(27.871f, 7.472f)
                lineTo(27.898f, 7.595f)
                lineTo(27.871f, 7.472f)
                close()
                moveTo(27.362f, 7.678f)
                lineTo(27.329f, 7.558f)
                lineTo(27.362f, 7.803f)
                verticalLineTo(7.678f)
                close()
                moveTo(27.362f, 7.852f)
                lineTo(27.266f, 7.772f)
                lineTo(27.362f, 7.852f)
                close()
                moveTo(27.086f, 7.913f)
                lineTo(27.072f, 8.037f)
                lineTo(27.086f, 7.913f)
                close()
                moveTo(27.05f, 8.026f)
                lineTo(27.146f, 7.946f)
                verticalLineTo(7.946f)
                lineTo(27.05f, 8.026f)
                close()
                moveTo(27.172f, 8.196f)
                lineTo(27.276f, 8.265f)
                lineTo(27.276f, 8.265f)
                lineTo(27.172f, 8.196f)
                close()
                moveTo(26.656f, 8.112f)
                lineTo(26.615f, 8.231f)
                lineTo(26.656f, 8.112f)
                close()
                moveTo(26.422f, 8.266f)
                lineTo(26.486f, 8.158f)
                lineTo(26.486f, 8.158f)
                lineTo(26.422f, 8.266f)
                close()
                moveTo(26.441f, 8.277f)
                lineTo(26.377f, 8.384f)
                lineTo(26.377f, 8.384f)
                lineTo(26.441f, 8.277f)
                close()
                moveTo(26.272f, 8.358f)
                lineTo(26.272f, 8.233f)
                lineTo(26.272f, 8.358f)
                close()
                moveTo(25.908f, 8.336f)
                lineTo(25.887f, 8.459f)
                lineTo(25.887f, 8.459f)
                lineTo(25.908f, 8.336f)
                close()
                moveTo(25.599f, 8.297f)
                lineTo(25.641f, 8.179f)
                lineTo(25.599f, 8.297f)
                close()
                moveTo(25.578f, 8.504f)
                lineTo(25.545f, 8.625f)
                lineTo(25.639f, 8.395f)
                lineTo(25.578f, 8.504f)
                close()
                moveTo(25.12f, 8.358f)
                lineTo(25.073f, 8.474f)
                lineTo(25.12f, 8.358f)
                close()
                moveTo(25.25f, 8.654f)
                lineTo(25.354f, 8.585f)
                lineTo(25.25f, 8.654f)
                close()
                moveTo(25.246f, 8.842f)
                lineTo(25.199f, 8.958f)
                horizontalLineTo(25.199f)
                lineTo(25.246f, 8.842f)
                close()
                moveTo(25.261f, 9.174f)
                lineTo(25.296f, 9.054f)
                lineTo(25.261f, 9.174f)
                close()
                moveTo(25.181f, 9.307f)
                lineTo(25.274f, 9.223f)
                lineTo(25.274f, 9.223f)
                lineTo(25.181f, 9.307f)
                close()
                moveTo(24.77f, 9.679f)
                lineTo(24.736f, 9.559f)
                lineTo(24.77f, 9.679f)
                close()
                moveTo(24.666f, 9.739f)
                lineTo(24.575f, 9.654f)
                verticalLineTo(9.654f)
                lineTo(24.666f, 9.739f)
                close()
                moveTo(24.594f, 9.857f)
                lineTo(24.716f, 9.887f)
                lineTo(24.716f, 9.887f)
                lineTo(24.594f, 9.857f)
                close()
                moveTo(24.45f, 9.784f)
                lineTo(24.345f, 9.853f)
                verticalLineTo(9.853f)
                lineTo(24.45f, 9.784f)
                close()
                moveTo(24.159f, 9.525f)
                lineTo(24.118f, 9.643f)
                lineTo(24.159f, 9.525f)
                close()
                moveTo(23.991f, 9.576f)
                lineTo(23.868f, 9.55f)
                verticalLineTo(9.55f)
                lineTo(23.991f, 9.576f)
                close()
                moveTo(23.893f, 9.739f)
                lineTo(23.821f, 9.637f)
                lineTo(23.893f, 9.739f)
                close()
                moveTo(23.849f, 9.89f)
                lineTo(23.758f, 9.976f)
                lineTo(23.849f, 9.89f)
                close()
                moveTo(23.3f, 9.817f)
                lineTo(23.175f, 9.809f)
                lineTo(23.3f, 9.817f)
                close()
                moveTo(23.221f, 9.973f)
                lineTo(23.29f, 10.078f)
                lineTo(23.221f, 9.973f)
                close()
                moveTo(23.155f, 9.94f)
                lineTo(23.28f, 9.948f)
                verticalLineTo(9.948f)
                lineTo(23.155f, 9.94f)
                close()
                moveTo(23.108f, 9.739f)
                lineTo(23.01f, 9.816f)
                verticalLineTo(9.816f)
                lineTo(23.108f, 9.739f)
                close()
                moveTo(23.126f, 9.447f)
                lineTo(23.011f, 9.398f)
                lineTo(23.011f, 9.398f)
                lineTo(23.126f, 9.447f)
                close()
                moveTo(23.108f, 9.425f)
                lineTo(23.191f, 9.519f)
                verticalLineTo(9.519f)
                lineTo(23.108f, 9.425f)
                close()
                moveTo(22.759f, 9.525f)
                lineTo(22.759f, 9.4f)
                horizontalLineTo(22.759f)
                verticalLineTo(9.525f)
                close()
                moveTo(22.635f, 9.614f)
                lineTo(22.538f, 9.535f)
                lineTo(22.635f, 9.614f)
                close()
                moveTo(23.396f, 9.067f)
                lineTo(23.466f, 9.17f)
                horizontalLineTo(23.466f)
                lineTo(23.396f, 9.067f)
                close()
                moveTo(23.474f, 9.017f)
                lineTo(23.415f, 8.907f)
                lineTo(23.474f, 9.017f)
                close()
                moveTo(23.36f, 8.816f)
                lineTo(23.302f, 8.927f)
                lineTo(23.36f, 8.816f)
                close()
                moveTo(23.133f, 8.49f)
                lineTo(23.018f, 8.443f)
                lineTo(23.133f, 8.49f)
                close()
                moveTo(23.25f, 7.975f)
                lineTo(23.128f, 7.947f)
                verticalLineTo(7.947f)
                lineTo(23.25f, 7.975f)
                close()
                moveTo(23.221f, 7.916f)
                lineTo(23.294f, 8.017f)
                lineTo(23.221f, 7.916f)
                close()
                moveTo(22.602f, 7.878f)
                lineTo(22.62f, 7.754f)
                lineTo(22.602f, 7.878f)
                close()
                moveTo(22.424f, 7.719f)
                lineTo(22.313f, 7.662f)
                verticalLineTo(7.662f)
                lineTo(22.424f, 7.719f)
                close()
                moveTo(22.399f, 7.603f)
                lineTo(22.452f, 7.717f)
                verticalLineTo(7.717f)
                lineTo(22.399f, 7.603f)
                close()
                moveTo(21.651f, 7.679f)
                lineTo(21.652f, 7.554f)
                lineTo(21.651f, 7.679f)
                close()
                moveTo(21.57f, 7.529f)
                lineTo(21.479f, 7.445f)
                lineTo(21.479f, 7.445f)
                lineTo(21.57f, 7.529f)
                close()
                moveTo(21.563f, 7.511f)
                lineTo(21.504f, 7.401f)
                verticalLineTo(7.401f)
                lineTo(21.563f, 7.511f)
                close()
                moveTo(21.042f, 7.533f)
                lineTo(21.15f, 7.471f)
                lineTo(21.15f, 7.471f)
                lineTo(21.042f, 7.533f)
                close()
                moveTo(20.866f, 7.439f)
                lineTo(20.865f, 7.314f)
                horizontalLineTo(20.865f)
                lineTo(20.866f, 7.439f)
                close()
                moveTo(20.474f, 7.357f)
                lineTo(20.405f, 7.461f)
                verticalLineTo(7.461f)
                lineTo(20.474f, 7.357f)
                close()
                moveTo(20.466f, 7.276f)
                lineTo(20.538f, 7.378f)
                lineTo(20.466f, 7.276f)
                close()
                moveTo(19.903f, 6.965f)
                lineTo(19.863f, 6.847f)
                lineTo(19.903f, 6.965f)
                close()
                moveTo(19.407f, 6.985f)
                lineTo(19.418f, 6.861f)
                horizontalLineTo(19.418f)
                lineTo(19.407f, 6.985f)
                close()
                moveTo(18.245f, 6.644f)
                lineTo(18.211f, 6.765f)
                lineTo(18.245f, 6.644f)
                close()
                moveTo(17.744f, 6.234f)
                lineTo(17.711f, 6.354f)
                horizontalLineTo(17.711f)
                lineTo(17.744f, 6.234f)
                close()
                moveTo(17.502f, 6.116f)
                lineTo(17.524f, 6.239f)
                horizontalLineTo(17.524f)
                lineTo(17.502f, 6.116f)
                close()
                moveTo(16.413f, 5.508f)
                lineTo(16.481f, 5.404f)
                horizontalLineTo(16.481f)
                lineTo(16.413f, 5.508f)
                close()
                moveTo(16.107f, 5.327f)
                lineTo(16.062f, 5.443f)
                horizontalLineTo(16.062f)
                lineTo(16.107f, 5.327f)
                close()
                moveTo(16.531f, 5.215f)
                lineTo(16.476f, 5.328f)
                horizontalLineTo(16.476f)
                lineTo(16.531f, 5.215f)
                close()
                moveTo(16.178f, 4.751f)
                lineTo(16.096f, 4.845f)
                horizontalLineTo(16.096f)
                lineTo(16.178f, 4.751f)
                close()
                moveTo(16.668f, 5.044f)
                lineTo(16.608f, 5.154f)
                lineTo(16.754f, 4.954f)
                lineTo(16.668f, 5.044f)
                close()
                moveTo(16.281f, 4.514f)
                lineTo(16.392f, 4.455f)
                lineTo(16.281f, 4.514f)
                close()
                moveTo(16.746f, 4.514f)
                lineTo(16.826f, 4.418f)
                verticalLineTo(4.418f)
                lineTo(16.746f, 4.514f)
                close()
                moveTo(17.048f, 4.049f)
                lineTo(17.138f, 3.962f)
                verticalLineTo(3.962f)
                lineTo(17.048f, 4.049f)
                close()
                moveTo(18.156f, 4.572f)
                lineTo(18.204f, 4.457f)
                lineTo(18.156f, 4.572f)
                close()
                moveTo(19.176f, 5.044f)
                lineTo(19.257f, 4.95f)
                verticalLineTo(4.95f)
                lineTo(19.176f, 5.044f)
                close()
                moveTo(19.04f, 4.683f)
                lineTo(18.934f, 4.75f)
                verticalLineTo(4.75f)
                lineTo(19.04f, 4.683f)
                close()
                moveTo(18.934f, 4.514f)
                lineTo(18.828f, 4.579f)
                verticalLineTo(4.579f)
                lineTo(18.934f, 4.514f)
                close()
                moveTo(19.814f, 4.783f)
                lineTo(19.762f, 4.896f)
                lineTo(19.814f, 4.783f)
                close()
                moveTo(20.866f, 5.215f)
                lineTo(20.834f, 5.336f)
                lineTo(20.866f, 5.215f)
                close()
                moveTo(21.461f, 5.408f)
                lineTo(21.502f, 5.29f)
                lineTo(21.461f, 5.408f)
                close()
                moveTo(23.474f, 4.514f)
                lineTo(23.515f, 4.632f)
                lineTo(23.474f, 4.514f)
                close()
                moveTo(24.138f, 4.629f)
                lineTo(24.207f, 4.525f)
                verticalLineTo(4.525f)
                lineTo(24.138f, 4.629f)
                close()
                moveTo(24.084f, 7.71f)
                lineTo(24.194f, 7.65f)
                lineTo(23.959f, 7.714f)
                lineTo(24.084f, 7.71f)
                close()
                moveTo(24.415f, 8.784f)
                lineTo(24.291f, 8.795f)
                verticalLineTo(8.795f)
                lineTo(24.415f, 8.784f)
                close()
                moveTo(24.524f, 9.049f)
                lineTo(24.638f, 8.997f)
                verticalLineTo(8.997f)
                lineTo(24.524f, 9.049f)
                close()
                moveTo(24.401f, 9.159f)
                lineTo(24.358f, 9.277f)
                lineTo(24.401f, 9.159f)
                close()
                moveTo(24.547f, 5.215f)
                curveTo(24.601f, 5.328f, 24.601f, 5.328f, 24.601f, 5.328f)
                curveTo(24.601f, 5.328f, 24.601f, 5.328f, 24.601f, 5.328f)
                curveTo(24.601f, 5.328f, 24.601f, 5.328f, 24.601f, 5.328f)
                curveTo(24.601f, 5.328f, 24.601f, 5.328f, 24.601f, 5.328f)
                curveTo(24.602f, 5.328f, 24.602f, 5.327f, 24.603f, 5.327f)
                curveTo(24.604f, 5.326f, 24.606f, 5.326f, 24.608f, 5.325f)
                curveTo(24.612f, 5.322f, 24.618f, 5.319f, 24.626f, 5.316f)
                curveTo(24.64f, 5.308f, 24.66f, 5.297f, 24.681f, 5.283f)
                curveTo(24.723f, 5.257f, 24.782f, 5.215f, 24.825f, 5.16f)
                curveTo(24.868f, 5.106f, 24.917f, 5.008f, 24.86f, 4.901f)
                curveTo(24.813f, 4.812f, 24.709f, 4.757f, 24.584f, 4.718f)
                lineTo(24.51f, 4.957f)
                curveTo(24.625f, 4.993f, 24.642f, 5.023f, 24.64f, 5.018f)
                curveTo(24.628f, 4.996f, 24.647f, 4.983f, 24.629f, 5.005f)
                curveTo(24.613f, 5.026f, 24.582f, 5.05f, 24.548f, 5.072f)
                curveTo(24.532f, 5.082f, 24.518f, 5.09f, 24.508f, 5.095f)
                curveTo(24.503f, 5.098f, 24.499f, 5.1f, 24.496f, 5.101f)
                curveTo(24.495f, 5.102f, 24.494f, 5.102f, 24.493f, 5.102f)
                curveTo(24.493f, 5.103f, 24.493f, 5.103f, 24.493f, 5.103f)
                curveTo(24.493f, 5.103f, 24.493f, 5.103f, 24.493f, 5.103f)
                curveTo(24.493f, 5.103f, 24.493f, 5.103f, 24.493f, 5.103f)
                curveTo(24.493f, 5.103f, 24.493f, 5.103f, 24.493f, 5.103f)
                curveTo(24.493f, 5.103f, 24.493f, 5.103f, 24.547f, 5.215f)
                close()
                moveTo(24.327f, 5.044f)
                curveTo(24.327f, 5.126f, 24.372f, 5.197f, 24.398f, 5.232f)
                curveTo(24.413f, 5.253f, 24.428f, 5.271f, 24.439f, 5.283f)
                curveTo(24.444f, 5.289f, 24.449f, 5.294f, 24.453f, 5.298f)
                curveTo(24.455f, 5.3f, 24.456f, 5.301f, 24.457f, 5.302f)
                curveTo(24.458f, 5.303f, 24.458f, 5.303f, 24.458f, 5.304f)
                curveTo(24.459f, 5.304f, 24.459f, 5.304f, 24.459f, 5.304f)
                curveTo(24.459f, 5.304f, 24.459f, 5.304f, 24.459f, 5.305f)
                curveTo(24.459f, 5.305f, 24.459f, 5.305f, 24.459f, 5.305f)
                curveTo(24.459f, 5.305f, 24.459f, 5.305f, 24.459f, 5.305f)
                curveTo(24.459f, 5.305f, 24.459f, 5.305f, 24.547f, 5.215f)
                curveTo(24.634f, 5.126f, 24.634f, 5.126f, 24.634f, 5.126f)
                curveTo(24.634f, 5.126f, 24.635f, 5.126f, 24.635f, 5.126f)
                curveTo(24.635f, 5.126f, 24.635f, 5.126f, 24.635f, 5.126f)
                curveTo(24.635f, 5.126f, 24.635f, 5.126f, 24.635f, 5.126f)
                curveTo(24.635f, 5.126f, 24.635f, 5.127f, 24.635f, 5.127f)
                curveTo(24.635f, 5.127f, 24.635f, 5.126f, 24.635f, 5.126f)
                curveTo(24.634f, 5.126f, 24.634f, 5.125f, 24.633f, 5.125f)
                curveTo(24.631f, 5.123f, 24.628f, 5.12f, 24.625f, 5.116f)
                curveTo(24.618f, 5.109f, 24.61f, 5.098f, 24.601f, 5.086f)
                curveTo(24.592f, 5.074f, 24.585f, 5.062f, 24.581f, 5.052f)
                curveTo(24.576f, 5.042f, 24.577f, 5.04f, 24.577f, 5.044f)
                horizontalLineTo(24.327f)
                close()
                moveTo(23.997f, 5.397f)
                curveTo(24.075f, 5.281f, 24.191f, 5.205f, 24.289f, 5.167f)
                curveTo(24.338f, 5.148f, 24.376f, 5.141f, 24.394f, 5.141f)
                curveTo(24.405f, 5.141f, 24.398f, 5.143f, 24.384f, 5.136f)
                curveTo(24.364f, 5.127f, 24.327f, 5.098f, 24.327f, 5.044f)
                horizontalLineTo(24.577f)
                curveTo(24.577f, 4.972f, 24.528f, 4.927f, 24.487f, 4.909f)
                curveTo(24.452f, 4.893f, 24.416f, 4.891f, 24.389f, 4.891f)
                curveTo(24.332f, 4.892f, 24.265f, 4.908f, 24.199f, 4.934f)
                curveTo(24.065f, 4.986f, 23.902f, 5.09f, 23.789f, 5.257f)
                lineTo(23.997f, 5.397f)
                close()
                moveTo(24.394f, 5.468f)
                curveTo(24.306f, 5.468f, 24.223f, 5.468f, 24.15f, 5.464f)
                curveTo(24.075f, 5.46f, 24.019f, 5.453f, 23.983f, 5.441f)
                curveTo(23.943f, 5.429f, 23.959f, 5.422f, 23.966f, 5.445f)
                curveTo(23.972f, 5.464f, 23.957f, 5.456f, 23.997f, 5.397f)
                lineTo(23.789f, 5.257f)
                curveTo(23.739f, 5.332f, 23.698f, 5.424f, 23.727f, 5.517f)
                curveTo(23.756f, 5.616f, 23.843f, 5.659f, 23.907f, 5.68f)
                curveTo(23.975f, 5.701f, 24.057f, 5.71f, 24.137f, 5.714f)
                curveTo(24.218f, 5.718f, 24.308f, 5.718f, 24.394f, 5.718f)
                lineTo(24.394f, 5.468f)
                close()
                moveTo(24.452f, 5.468f)
                curveTo(24.432f, 5.468f, 24.413f, 5.468f, 24.394f, 5.468f)
                lineTo(24.394f, 5.718f)
                curveTo(24.414f, 5.718f, 24.433f, 5.718f, 24.452f, 5.718f)
                verticalLineTo(5.468f)
                close()
                moveTo(25.238f, 5.436f)
                curveTo(24.949f, 5.452f, 24.645f, 5.468f, 24.452f, 5.468f)
                verticalLineTo(5.718f)
                curveTo(24.653f, 5.718f, 24.966f, 5.701f, 25.251f, 5.686f)
                lineTo(25.238f, 5.436f)
                close()
                moveTo(25.857f, 5.41f)
                curveTo(25.723f, 5.41f, 25.485f, 5.423f, 25.238f, 5.436f)
                lineTo(25.251f, 5.686f)
                curveTo(25.502f, 5.673f, 25.731f, 5.66f, 25.857f, 5.66f)
                verticalLineTo(5.41f)
                close()
                moveTo(26.573f, 5.218f)
                curveTo(26.394f, 5.32f, 26.281f, 5.365f, 26.184f, 5.387f)
                curveTo(26.086f, 5.41f, 25.998f, 5.41f, 25.857f, 5.41f)
                verticalLineTo(5.66f)
                curveTo(25.993f, 5.66f, 26.11f, 5.661f, 26.24f, 5.631f)
                curveTo(26.371f, 5.601f, 26.507f, 5.543f, 26.696f, 5.436f)
                lineTo(26.573f, 5.218f)
                close()
                moveTo(28.225f, 4.779f)
                curveTo(27.931f, 4.841f, 27.585f, 4.914f, 27.282f, 4.988f)
                curveTo(27.13f, 5.026f, 26.988f, 5.064f, 26.868f, 5.101f)
                curveTo(26.75f, 5.138f, 26.645f, 5.177f, 26.573f, 5.218f)
                lineTo(26.696f, 5.436f)
                curveTo(26.743f, 5.409f, 26.827f, 5.376f, 26.942f, 5.34f)
                curveTo(27.056f, 5.304f, 27.192f, 5.268f, 27.341f, 5.231f)
                curveTo(27.64f, 5.158f, 27.982f, 5.086f, 28.276f, 5.024f)
                lineTo(28.225f, 4.779f)
                close()
                moveTo(28.861f, 4.634f)
                curveTo(28.83f, 4.645f, 28.755f, 4.665f, 28.638f, 4.691f)
                curveTo(28.525f, 4.716f, 28.383f, 4.746f, 28.225f, 4.779f)
                lineTo(28.276f, 5.024f)
                curveTo(28.434f, 4.991f, 28.578f, 4.961f, 28.693f, 4.935f)
                curveTo(28.805f, 4.91f, 28.899f, 4.887f, 28.949f, 4.868f)
                lineTo(28.861f, 4.634f)
                close()
                moveTo(28.673f, 5.122f)
                curveTo(28.761f, 5.211f, 28.761f, 5.211f, 28.761f, 5.211f)
                curveTo(28.761f, 5.211f, 28.761f, 5.211f, 28.761f, 5.211f)
                curveTo(28.761f, 5.211f, 28.761f, 5.211f, 28.761f, 5.211f)
                curveTo(28.761f, 5.211f, 28.761f, 5.211f, 28.761f, 5.211f)
                curveTo(28.762f, 5.21f, 28.762f, 5.21f, 28.763f, 5.21f)
                curveTo(28.763f, 5.209f, 28.765f, 5.207f, 28.767f, 5.206f)
                curveTo(28.77f, 5.202f, 28.775f, 5.197f, 28.781f, 5.191f)
                curveTo(28.794f, 5.178f, 28.812f, 5.16f, 28.832f, 5.139f)
                curveTo(28.873f, 5.096f, 28.926f, 5.039f, 28.972f, 4.984f)
                curveTo(28.995f, 4.957f, 29.017f, 4.929f, 29.036f, 4.902f)
                curveTo(29.053f, 4.878f, 29.073f, 4.846f, 29.084f, 4.814f)
                curveTo(29.09f, 4.799f, 29.098f, 4.77f, 29.093f, 4.735f)
                curveTo(29.087f, 4.691f, 29.06f, 4.649f, 29.012f, 4.628f)
                curveTo(28.975f, 4.611f, 28.94f, 4.614f, 28.922f, 4.617f)
                curveTo(28.901f, 4.62f, 28.88f, 4.627f, 28.861f, 4.634f)
                lineTo(28.949f, 4.868f)
                curveTo(28.959f, 4.864f, 28.962f, 4.864f, 28.959f, 4.864f)
                curveTo(28.958f, 4.865f, 28.953f, 4.865f, 28.945f, 4.865f)
                curveTo(28.938f, 4.864f, 28.926f, 4.863f, 28.911f, 4.856f)
                curveTo(28.873f, 4.839f, 28.851f, 4.804f, 28.846f, 4.771f)
                curveTo(28.844f, 4.757f, 28.845f, 4.747f, 28.846f, 4.741f)
                curveTo(28.847f, 4.736f, 28.848f, 4.732f, 28.849f, 4.731f)
                curveTo(28.849f, 4.729f, 28.846f, 4.738f, 28.831f, 4.759f)
                curveTo(28.818f, 4.777f, 28.801f, 4.799f, 28.78f, 4.824f)
                curveTo(28.739f, 4.873f, 28.691f, 4.925f, 28.652f, 4.966f)
                curveTo(28.632f, 4.986f, 28.615f, 5.003f, 28.604f, 5.015f)
                curveTo(28.598f, 5.021f, 28.593f, 5.026f, 28.59f, 5.029f)
                curveTo(28.588f, 5.03f, 28.587f, 5.031f, 28.586f, 5.032f)
                curveTo(28.586f, 5.033f, 28.586f, 5.033f, 28.585f, 5.033f)
                curveTo(28.585f, 5.033f, 28.585f, 5.033f, 28.585f, 5.033f)
                curveTo(28.585f, 5.033f, 28.585f, 5.033f, 28.585f, 5.033f)
                curveTo(28.585f, 5.033f, 28.585f, 5.033f, 28.585f, 5.033f)
                curveTo(28.585f, 5.033f, 28.585f, 5.033f, 28.673f, 5.122f)
                close()
                moveTo(30.757f, 4.198f)
                curveTo(30.677f, 4.244f, 30.507f, 4.318f, 30.287f, 4.405f)
                curveTo(30.071f, 4.49f, 29.815f, 4.586f, 29.57f, 4.674f)
                curveTo(29.324f, 4.763f, 29.09f, 4.846f, 28.917f, 4.906f)
                curveTo(28.831f, 4.936f, 28.76f, 4.961f, 28.71f, 4.978f)
                curveTo(28.685f, 4.986f, 28.666f, 4.993f, 28.653f, 4.997f)
                curveTo(28.646f, 4.999f, 28.641f, 5.001f, 28.638f, 5.002f)
                curveTo(28.636f, 5.003f, 28.635f, 5.003f, 28.634f, 5.004f)
                curveTo(28.634f, 5.004f, 28.633f, 5.004f, 28.633f, 5.004f)
                curveTo(28.633f, 5.004f, 28.633f, 5.004f, 28.633f, 5.004f)
                curveTo(28.633f, 5.004f, 28.633f, 5.004f, 28.633f, 5.004f)
                curveTo(28.633f, 5.004f, 28.633f, 5.004f, 28.673f, 5.122f)
                curveTo(28.713f, 5.241f, 28.713f, 5.241f, 28.713f, 5.241f)
                curveTo(28.713f, 5.241f, 28.713f, 5.241f, 28.713f, 5.241f)
                curveTo(28.713f, 5.241f, 28.714f, 5.241f, 28.714f, 5.24f)
                curveTo(28.714f, 5.24f, 28.714f, 5.24f, 28.715f, 5.24f)
                curveTo(28.716f, 5.24f, 28.717f, 5.239f, 28.719f, 5.239f)
                curveTo(28.722f, 5.238f, 28.727f, 5.236f, 28.734f, 5.234f)
                curveTo(28.747f, 5.229f, 28.766f, 5.222f, 28.791f, 5.214f)
                curveTo(28.841f, 5.197f, 28.912f, 5.172f, 28.999f, 5.142f)
                curveTo(29.173f, 5.082f, 29.408f, 4.999f, 29.655f, 4.91f)
                curveTo(29.901f, 4.82f, 30.16f, 4.724f, 30.379f, 4.637f)
                curveTo(30.596f, 4.552f, 30.784f, 4.471f, 30.883f, 4.414f)
                lineTo(30.757f, 4.198f)
                close()
                moveTo(30.869f, 4.55f)
                curveTo(30.91f, 4.506f, 30.948f, 4.464f, 30.979f, 4.429f)
                curveTo(31.006f, 4.398f, 31.037f, 4.361f, 31.053f, 4.329f)
                curveTo(31.058f, 4.321f, 31.065f, 4.306f, 31.069f, 4.287f)
                curveTo(31.073f, 4.271f, 31.08f, 4.229f, 31.053f, 4.187f)
                curveTo(31.023f, 4.139f, 30.976f, 4.128f, 30.952f, 4.126f)
                curveTo(30.928f, 4.124f, 30.909f, 4.128f, 30.898f, 4.131f)
                curveTo(30.86f, 4.141f, 30.81f, 4.167f, 30.757f, 4.198f)
                lineTo(30.883f, 4.414f)
                curveTo(30.909f, 4.399f, 30.929f, 4.388f, 30.944f, 4.381f)
                curveTo(30.96f, 4.373f, 30.964f, 4.372f, 30.961f, 4.373f)
                curveTo(30.96f, 4.373f, 30.948f, 4.376f, 30.931f, 4.375f)
                curveTo(30.912f, 4.373f, 30.868f, 4.363f, 30.841f, 4.319f)
                curveTo(30.816f, 4.28f, 30.823f, 4.242f, 30.825f, 4.233f)
                curveTo(30.828f, 4.22f, 30.832f, 4.212f, 30.833f, 4.212f)
                curveTo(30.833f, 4.211f, 30.831f, 4.215f, 30.822f, 4.226f)
                curveTo(30.814f, 4.237f, 30.803f, 4.25f, 30.79f, 4.266f)
                curveTo(30.762f, 4.297f, 30.726f, 4.336f, 30.685f, 4.382f)
                lineTo(30.869f, 4.55f)
                close()
                moveTo(30.563f, 4.911f)
                curveTo(30.647f, 4.794f, 30.767f, 4.663f, 30.869f, 4.55f)
                lineTo(30.685f, 4.382f)
                curveTo(30.585f, 4.491f, 30.454f, 4.634f, 30.36f, 4.765f)
                lineTo(30.563f, 4.911f)
                close()
                moveTo(30.892f, 4.519f)
                curveTo(30.718f, 4.633f, 30.562f, 4.735f, 30.469f, 4.783f)
                curveTo(30.446f, 4.795f, 30.431f, 4.801f, 30.424f, 4.803f)
                curveTo(30.42f, 4.804f, 30.423f, 4.803f, 30.43f, 4.802f)
                curveTo(30.434f, 4.802f, 30.46f, 4.799f, 30.489f, 4.816f)
                curveTo(30.527f, 4.837f, 30.544f, 4.875f, 30.547f, 4.905f)
                curveTo(30.549f, 4.927f, 30.542f, 4.942f, 30.542f, 4.942f)
                curveTo(30.542f, 4.944f, 30.546f, 4.935f, 30.563f, 4.911f)
                lineTo(30.36f, 4.765f)
                curveTo(30.34f, 4.793f, 30.32f, 4.824f, 30.309f, 4.854f)
                curveTo(30.303f, 4.868f, 30.295f, 4.895f, 30.298f, 4.926f)
                curveTo(30.301f, 4.965f, 30.322f, 5.008f, 30.366f, 5.034f)
                curveTo(30.402f, 5.054f, 30.436f, 5.053f, 30.453f, 5.051f)
                curveTo(30.471f, 5.049f, 30.488f, 5.045f, 30.501f, 5.041f)
                curveTo(30.528f, 5.032f, 30.556f, 5.019f, 30.583f, 5.005f)
                curveTo(30.691f, 4.949f, 30.861f, 4.839f, 31.029f, 4.729f)
                lineTo(30.892f, 4.519f)
                close()
                moveTo(31.416f, 4.195f)
                curveTo(31.272f, 4.271f, 31.073f, 4.401f, 30.892f, 4.519f)
                lineTo(31.029f, 4.729f)
                curveTo(31.214f, 4.608f, 31.401f, 4.486f, 31.532f, 4.416f)
                lineTo(31.416f, 4.195f)
                close()
                moveTo(31.236f, 4.935f)
                curveTo(31.353f, 4.84f, 31.538f, 4.647f, 31.645f, 4.502f)
                curveTo(31.672f, 4.466f, 31.697f, 4.428f, 31.715f, 4.394f)
                curveTo(31.724f, 4.377f, 31.733f, 4.358f, 31.739f, 4.337f)
                curveTo(31.744f, 4.318f, 31.751f, 4.286f, 31.743f, 4.25f)
                curveTo(31.734f, 4.205f, 31.703f, 4.165f, 31.656f, 4.147f)
                curveTo(31.618f, 4.132f, 31.583f, 4.135f, 31.561f, 4.139f)
                curveTo(31.517f, 4.146f, 31.467f, 4.168f, 31.416f, 4.195f)
                lineTo(31.532f, 4.416f)
                curveTo(31.555f, 4.405f, 31.572f, 4.397f, 31.585f, 4.392f)
                curveTo(31.598f, 4.386f, 31.604f, 4.385f, 31.604f, 4.385f)
                curveTo(31.604f, 4.385f, 31.6f, 4.386f, 31.594f, 4.385f)
                curveTo(31.588f, 4.385f, 31.577f, 4.384f, 31.563f, 4.379f)
                curveTo(31.529f, 4.365f, 31.506f, 4.335f, 31.499f, 4.303f)
                curveTo(31.496f, 4.29f, 31.497f, 4.281f, 31.497f, 4.275f)
                curveTo(31.498f, 4.27f, 31.499f, 4.267f, 31.499f, 4.266f)
                curveTo(31.499f, 4.266f, 31.498f, 4.27f, 31.493f, 4.279f)
                curveTo(31.484f, 4.296f, 31.468f, 4.322f, 31.444f, 4.353f)
                curveTo(31.349f, 4.482f, 31.178f, 4.66f, 31.078f, 4.741f)
                lineTo(31.236f, 4.935f)
                close()
                moveTo(31.847f, 4.559f)
                curveTo(31.74f, 4.634f, 31.514f, 4.717f, 31.333f, 4.76f)
                curveTo(31.289f, 4.77f, 31.251f, 4.778f, 31.22f, 4.782f)
                curveTo(31.204f, 4.784f, 31.191f, 4.785f, 31.181f, 4.785f)
                curveTo(31.177f, 4.786f, 31.173f, 4.786f, 31.17f, 4.786f)
                curveTo(31.168f, 4.785f, 31.167f, 4.785f, 31.166f, 4.785f)
                curveTo(31.166f, 4.785f, 31.166f, 4.785f, 31.166f, 4.785f)
                curveTo(31.165f, 4.785f, 31.165f, 4.785f, 31.165f, 4.785f)
                curveTo(31.165f, 4.785f, 31.165f, 4.785f, 31.166f, 4.785f)
                curveTo(31.166f, 4.785f, 31.166f, 4.785f, 31.167f, 4.785f)
                curveTo(31.167f, 4.786f, 31.169f, 4.786f, 31.171f, 4.787f)
                curveTo(31.175f, 4.788f, 31.183f, 4.791f, 31.193f, 4.797f)
                curveTo(31.217f, 4.812f, 31.243f, 4.846f, 31.242f, 4.892f)
                curveTo(31.241f, 4.91f, 31.236f, 4.924f, 31.233f, 4.931f)
                curveTo(31.229f, 4.938f, 31.226f, 4.943f, 31.225f, 4.944f)
                curveTo(31.224f, 4.946f, 31.226f, 4.943f, 31.236f, 4.935f)
                lineTo(31.078f, 4.741f)
                curveTo(31.061f, 4.755f, 31.043f, 4.771f, 31.028f, 4.789f)
                curveTo(31.016f, 4.805f, 30.993f, 4.838f, 30.992f, 4.883f)
                curveTo(30.99f, 4.942f, 31.022f, 4.984f, 31.057f, 5.007f)
                curveTo(31.085f, 5.025f, 31.115f, 5.031f, 31.132f, 5.033f)
                curveTo(31.17f, 5.038f, 31.213f, 5.035f, 31.252f, 5.03f)
                curveTo(31.294f, 5.024f, 31.341f, 5.015f, 31.39f, 5.003f)
                curveTo(31.582f, 4.958f, 31.845f, 4.866f, 31.99f, 4.764f)
                lineTo(31.847f, 4.559f)
                close()
                moveTo(31.892f, 5.024f)
                curveTo(31.961f, 4.932f, 32.045f, 4.82f, 32.087f, 4.748f)
                curveTo(32.097f, 4.73f, 32.109f, 4.707f, 32.116f, 4.684f)
                curveTo(32.12f, 4.674f, 32.125f, 4.654f, 32.125f, 4.63f)
                curveTo(32.125f, 4.606f, 32.117f, 4.559f, 32.072f, 4.525f)
                curveTo(32.031f, 4.495f, 31.988f, 4.498f, 31.969f, 4.5f)
                curveTo(31.949f, 4.503f, 31.932f, 4.51f, 31.92f, 4.515f)
                curveTo(31.897f, 4.526f, 31.872f, 4.542f, 31.847f, 4.559f)
                lineTo(31.99f, 4.764f)
                curveTo(32.011f, 4.749f, 32.022f, 4.744f, 32.024f, 4.743f)
                curveTo(32.025f, 4.742f, 32.019f, 4.746f, 32.006f, 4.747f)
                curveTo(31.996f, 4.749f, 31.959f, 4.753f, 31.922f, 4.725f)
                curveTo(31.881f, 4.695f, 31.875f, 4.652f, 31.875f, 4.635f)
                curveTo(31.875f, 4.618f, 31.879f, 4.607f, 31.879f, 4.607f)
                curveTo(31.879f, 4.604f, 31.878f, 4.609f, 31.87f, 4.623f)
                curveTo(31.838f, 4.679f, 31.766f, 4.776f, 31.692f, 4.874f)
                lineTo(31.892f, 5.024f)
                close()
                moveTo(31.772f, 5.19f)
                curveTo(31.795f, 5.154f, 31.84f, 5.094f, 31.892f, 5.024f)
                lineTo(31.692f, 4.874f)
                curveTo(31.642f, 4.941f, 31.591f, 5.009f, 31.562f, 5.054f)
                lineTo(31.772f, 5.19f)
                close()
                moveTo(31.767f, 5.197f)
                lineTo(31.772f, 5.19f)
                lineTo(31.562f, 5.054f)
                lineTo(31.558f, 5.061f)
                lineTo(31.767f, 5.197f)
                close()
                moveTo(31.767f, 5.202f)
                curveTo(31.74f, 5.202f, 31.719f, 5.201f, 31.701f, 5.2f)
                curveTo(31.684f, 5.198f, 31.674f, 5.197f, 31.668f, 5.195f)
                curveTo(31.666f, 5.195f, 31.665f, 5.195f, 31.667f, 5.195f)
                curveTo(31.668f, 5.196f, 31.672f, 5.197f, 31.677f, 5.201f)
                curveTo(31.683f, 5.205f, 31.689f, 5.21f, 31.696f, 5.219f)
                curveTo(31.702f, 5.228f, 31.708f, 5.238f, 31.711f, 5.248f)
                curveTo(31.717f, 5.269f, 31.714f, 5.284f, 31.713f, 5.287f)
                curveTo(31.712f, 5.289f, 31.712f, 5.289f, 31.713f, 5.288f)
                curveTo(31.713f, 5.286f, 31.715f, 5.284f, 31.717f, 5.28f)
                curveTo(31.721f, 5.271f, 31.727f, 5.261f, 31.736f, 5.246f)
                curveTo(31.745f, 5.232f, 31.755f, 5.216f, 31.767f, 5.197f)
                lineTo(31.558f, 5.061f)
                curveTo(31.535f, 5.096f, 31.51f, 5.134f, 31.493f, 5.167f)
                curveTo(31.48f, 5.192f, 31.451f, 5.253f, 31.471f, 5.32f)
                curveTo(31.496f, 5.402f, 31.57f, 5.429f, 31.61f, 5.439f)
                curveTo(31.653f, 5.449f, 31.708f, 5.452f, 31.767f, 5.452f)
                verticalLineTo(5.202f)
                close()
                moveTo(31.157f, 5.883f)
                curveTo(31.225f, 5.987f, 31.225f, 5.987f, 31.225f, 5.987f)
                curveTo(31.225f, 5.987f, 31.225f, 5.987f, 31.225f, 5.987f)
                curveTo(31.226f, 5.987f, 31.226f, 5.987f, 31.226f, 5.987f)
                curveTo(31.226f, 5.987f, 31.226f, 5.987f, 31.226f, 5.987f)
                curveTo(31.226f, 5.986f, 31.227f, 5.986f, 31.228f, 5.985f)
                curveTo(31.23f, 5.984f, 31.232f, 5.983f, 31.235f, 5.981f)
                curveTo(31.242f, 5.976f, 31.251f, 5.97f, 31.262f, 5.963f)
                curveTo(31.285f, 5.947f, 31.318f, 5.925f, 31.356f, 5.899f)
                curveTo(31.433f, 5.846f, 31.533f, 5.775f, 31.627f, 5.704f)
                curveTo(31.718f, 5.635f, 31.81f, 5.559f, 31.865f, 5.497f)
                curveTo(31.88f, 5.48f, 31.894f, 5.462f, 31.906f, 5.443f)
                curveTo(31.916f, 5.426f, 31.933f, 5.394f, 31.934f, 5.355f)
                curveTo(31.935f, 5.333f, 31.931f, 5.307f, 31.917f, 5.282f)
                curveTo(31.904f, 5.256f, 31.884f, 5.238f, 31.864f, 5.226f)
                curveTo(31.828f, 5.204f, 31.79f, 5.202f, 31.767f, 5.202f)
                verticalLineTo(5.452f)
                curveTo(31.774f, 5.452f, 31.758f, 5.454f, 31.735f, 5.44f)
                curveTo(31.722f, 5.432f, 31.707f, 5.419f, 31.697f, 5.399f)
                curveTo(31.686f, 5.38f, 31.684f, 5.361f, 31.684f, 5.346f)
                curveTo(31.685f, 5.322f, 31.694f, 5.309f, 31.692f, 5.314f)
                curveTo(31.691f, 5.315f, 31.687f, 5.321f, 31.678f, 5.331f)
                curveTo(31.641f, 5.373f, 31.566f, 5.436f, 31.475f, 5.505f)
                curveTo(31.386f, 5.573f, 31.29f, 5.641f, 31.215f, 5.693f)
                curveTo(31.177f, 5.718f, 31.146f, 5.74f, 31.123f, 5.755f)
                curveTo(31.112f, 5.762f, 31.103f, 5.768f, 31.097f, 5.772f)
                curveTo(31.094f, 5.774f, 31.092f, 5.776f, 31.09f, 5.777f)
                curveTo(31.09f, 5.777f, 31.089f, 5.777f, 31.089f, 5.778f)
                curveTo(31.089f, 5.778f, 31.088f, 5.778f, 31.088f, 5.778f)
                curveTo(31.088f, 5.778f, 31.088f, 5.778f, 31.088f, 5.778f)
                curveTo(31.088f, 5.778f, 31.088f, 5.778f, 31.088f, 5.778f)
                curveTo(31.088f, 5.778f, 31.088f, 5.778f, 31.157f, 5.883f)
                close()
                moveTo(31.26f, 6.289f)
                curveTo(31.327f, 6.192f, 31.368f, 6.11f, 31.385f, 6.04f)
                curveTo(31.402f, 5.967f, 31.397f, 5.891f, 31.347f, 5.832f)
                curveTo(31.302f, 5.778f, 31.241f, 5.764f, 31.209f, 5.759f)
                curveTo(31.191f, 5.757f, 31.175f, 5.757f, 31.163f, 5.757f)
                curveTo(31.157f, 5.757f, 31.153f, 5.757f, 31.149f, 5.758f)
                curveTo(31.147f, 5.758f, 31.145f, 5.758f, 31.144f, 5.758f)
                curveTo(31.143f, 5.758f, 31.142f, 5.758f, 31.142f, 5.759f)
                curveTo(31.141f, 5.759f, 31.141f, 5.759f, 31.141f, 5.759f)
                curveTo(31.141f, 5.759f, 31.141f, 5.759f, 31.14f, 5.759f)
                curveTo(31.14f, 5.759f, 31.14f, 5.759f, 31.14f, 5.759f)
                curveTo(31.14f, 5.759f, 31.14f, 5.759f, 31.157f, 5.883f)
                curveTo(31.173f, 6.006f, 31.173f, 6.006f, 31.173f, 6.006f)
                curveTo(31.173f, 6.007f, 31.173f, 6.007f, 31.173f, 6.007f)
                curveTo(31.173f, 6.007f, 31.173f, 6.007f, 31.173f, 6.007f)
                curveTo(31.173f, 6.007f, 31.172f, 6.007f, 31.172f, 6.007f)
                curveTo(31.172f, 6.007f, 31.172f, 6.007f, 31.171f, 6.007f)
                curveTo(31.171f, 6.007f, 31.171f, 6.007f, 31.17f, 6.007f)
                curveTo(31.17f, 6.007f, 31.17f, 6.007f, 31.171f, 6.007f)
                curveTo(31.173f, 6.007f, 31.174f, 6.007f, 31.176f, 6.007f)
                curveTo(31.183f, 6.008f, 31.169f, 6.008f, 31.156f, 5.992f)
                curveTo(31.137f, 5.97f, 31.148f, 5.955f, 31.142f, 5.981f)
                curveTo(31.135f, 6.008f, 31.113f, 6.061f, 31.053f, 6.148f)
                lineTo(31.26f, 6.289f)
                close()
                moveTo(29.732f, 6.956f)
                curveTo(30.025f, 6.867f, 30.357f, 6.766f, 30.635f, 6.659f)
                curveTo(30.775f, 6.606f, 30.903f, 6.55f, 31.009f, 6.492f)
                curveTo(31.11f, 6.436f, 31.205f, 6.369f, 31.26f, 6.289f)
                lineTo(31.053f, 6.148f)
                curveTo(31.034f, 6.177f, 30.983f, 6.22f, 30.888f, 6.273f)
                curveTo(30.797f, 6.323f, 30.68f, 6.374f, 30.546f, 6.426f)
                curveTo(30.278f, 6.528f, 29.954f, 6.627f, 29.659f, 6.717f)
                lineTo(29.732f, 6.956f)
                close()
                moveTo(29.015f, 7.194f)
                curveTo(29.006f, 7.211f, 28.996f, 7.215f, 29.005f, 7.209f)
                curveTo(29.011f, 7.205f, 29.023f, 7.198f, 29.042f, 7.189f)
                curveTo(29.079f, 7.17f, 29.133f, 7.149f, 29.202f, 7.124f)
                curveTo(29.34f, 7.075f, 29.526f, 7.018f, 29.732f, 6.956f)
                lineTo(29.659f, 6.717f)
                curveTo(29.455f, 6.779f, 29.264f, 6.837f, 29.118f, 6.888f)
                curveTo(29.046f, 6.914f, 28.982f, 6.94f, 28.931f, 6.964f)
                curveTo(28.906f, 6.977f, 28.882f, 6.99f, 28.86f, 7.005f)
                curveTo(28.841f, 7.019f, 28.813f, 7.042f, 28.795f, 7.076f)
                lineTo(29.015f, 7.194f)
                close()
                moveTo(27.898f, 7.595f)
                curveTo(28.051f, 7.561f, 28.297f, 7.507f, 28.513f, 7.446f)
                curveTo(28.62f, 7.415f, 28.724f, 7.381f, 28.807f, 7.346f)
                curveTo(28.849f, 7.329f, 28.888f, 7.309f, 28.922f, 7.288f)
                curveTo(28.952f, 7.269f, 28.992f, 7.238f, 29.015f, 7.194f)
                lineTo(28.795f, 7.076f)
                curveTo(28.802f, 7.063f, 28.806f, 7.065f, 28.787f, 7.077f)
                curveTo(28.77f, 7.088f, 28.744f, 7.101f, 28.71f, 7.116f)
                curveTo(28.641f, 7.145f, 28.548f, 7.175f, 28.444f, 7.205f)
                curveTo(28.237f, 7.264f, 27.999f, 7.316f, 27.844f, 7.35f)
                lineTo(27.898f, 7.595f)
                close()
                moveTo(27.719f, 7.386f)
                curveTo(27.72f, 7.386f, 27.726f, 7.386f, 27.734f, 7.387f)
                curveTo(27.738f, 7.387f, 27.748f, 7.389f, 27.761f, 7.394f)
                curveTo(27.767f, 7.396f, 27.808f, 7.412f, 27.829f, 7.459f)
                curveTo(27.857f, 7.521f, 27.826f, 7.572f, 27.812f, 7.589f)
                curveTo(27.799f, 7.605f, 27.784f, 7.614f, 27.78f, 7.616f)
                curveTo(27.771f, 7.622f, 27.762f, 7.625f, 27.762f, 7.625f)
                curveTo(27.758f, 7.627f, 27.76f, 7.626f, 27.775f, 7.622f)
                curveTo(27.801f, 7.616f, 27.842f, 7.607f, 27.898f, 7.595f)
                lineTo(27.844f, 7.35f)
                curveTo(27.79f, 7.362f, 27.745f, 7.372f, 27.716f, 7.379f)
                curveTo(27.704f, 7.382f, 27.687f, 7.386f, 27.674f, 7.391f)
                curveTo(27.672f, 7.392f, 27.662f, 7.396f, 27.651f, 7.402f)
                curveTo(27.646f, 7.405f, 27.632f, 7.414f, 27.618f, 7.431f)
                curveTo(27.604f, 7.448f, 27.573f, 7.499f, 27.601f, 7.561f)
                curveTo(27.622f, 7.609f, 27.663f, 7.624f, 27.67f, 7.627f)
                curveTo(27.683f, 7.632f, 27.694f, 7.634f, 27.698f, 7.634f)
                curveTo(27.708f, 7.636f, 27.716f, 7.636f, 27.719f, 7.636f)
                verticalLineTo(7.386f)
                close()
                moveTo(27.794f, 7.728f)
                curveTo(27.819f, 7.728f, 27.844f, 7.727f, 27.868f, 7.721f)
                curveTo(27.887f, 7.717f, 27.927f, 7.705f, 27.957f, 7.668f)
                curveTo(27.997f, 7.62f, 27.994f, 7.563f, 27.977f, 7.525f)
                curveTo(27.963f, 7.493f, 27.942f, 7.473f, 27.929f, 7.462f)
                curveTo(27.901f, 7.438f, 27.865f, 7.42f, 27.833f, 7.408f)
                curveTo(27.801f, 7.396f, 27.761f, 7.386f, 27.719f, 7.386f)
                verticalLineTo(7.636f)
                curveTo(27.719f, 7.636f, 27.72f, 7.636f, 27.722f, 7.636f)
                curveTo(27.723f, 7.636f, 27.726f, 7.636f, 27.728f, 7.637f)
                curveTo(27.733f, 7.638f, 27.74f, 7.64f, 27.746f, 7.642f)
                curveTo(27.761f, 7.648f, 27.768f, 7.653f, 27.767f, 7.652f)
                curveTo(27.766f, 7.652f, 27.764f, 7.65f, 27.761f, 7.646f)
                curveTo(27.758f, 7.642f, 27.752f, 7.635f, 27.747f, 7.623f)
                curveTo(27.742f, 7.612f, 27.737f, 7.593f, 27.739f, 7.571f)
                curveTo(27.741f, 7.547f, 27.751f, 7.526f, 27.764f, 7.509f)
                curveTo(27.776f, 7.495f, 27.789f, 7.487f, 27.797f, 7.483f)
                curveTo(27.804f, 7.479f, 27.81f, 7.478f, 27.811f, 7.478f)
                curveTo(27.813f, 7.477f, 27.809f, 7.478f, 27.794f, 7.478f)
                verticalLineTo(7.728f)
                close()
                moveTo(27.362f, 7.678f)
                curveTo(27.395f, 7.799f, 27.395f, 7.799f, 27.395f, 7.799f)
                curveTo(27.395f, 7.799f, 27.395f, 7.799f, 27.395f, 7.799f)
                curveTo(27.395f, 7.799f, 27.395f, 7.799f, 27.395f, 7.799f)
                curveTo(27.395f, 7.799f, 27.395f, 7.799f, 27.395f, 7.799f)
                curveTo(27.395f, 7.799f, 27.395f, 7.799f, 27.395f, 7.799f)
                curveTo(27.396f, 7.799f, 27.396f, 7.798f, 27.397f, 7.798f)
                curveTo(27.399f, 7.798f, 27.402f, 7.797f, 27.406f, 7.796f)
                curveTo(27.413f, 7.794f, 27.424f, 7.791f, 27.438f, 7.788f)
                curveTo(27.465f, 7.781f, 27.503f, 7.772f, 27.545f, 7.763f)
                curveTo(27.633f, 7.744f, 27.73f, 7.728f, 27.794f, 7.728f)
                verticalLineTo(7.478f)
                curveTo(27.701f, 7.478f, 27.582f, 7.5f, 27.493f, 7.518f)
                curveTo(27.447f, 7.528f, 27.407f, 7.538f, 27.377f, 7.545f)
                curveTo(27.363f, 7.549f, 27.351f, 7.552f, 27.343f, 7.554f)
                curveTo(27.338f, 7.555f, 27.335f, 7.556f, 27.333f, 7.557f)
                curveTo(27.332f, 7.557f, 27.331f, 7.557f, 27.33f, 7.557f)
                curveTo(27.33f, 7.557f, 27.33f, 7.557f, 27.33f, 7.557f)
                curveTo(27.33f, 7.557f, 27.329f, 7.557f, 27.329f, 7.557f)
                curveTo(27.329f, 7.557f, 27.329f, 7.557f, 27.329f, 7.557f)
                curveTo(27.329f, 7.557f, 27.329f, 7.558f, 27.329f, 7.558f)
                curveTo(27.329f, 7.558f, 27.329f, 7.558f, 27.362f, 7.678f)
                close()
                moveTo(27.458f, 7.932f)
                curveTo(27.499f, 7.883f, 27.53f, 7.834f, 27.544f, 7.785f)
                curveTo(27.559f, 7.73f, 27.553f, 7.669f, 27.512f, 7.62f)
                curveTo(27.478f, 7.579f, 27.434f, 7.565f, 27.412f, 7.559f)
                curveTo(27.399f, 7.556f, 27.388f, 7.555f, 27.379f, 7.554f)
                curveTo(27.375f, 7.554f, 27.372f, 7.553f, 27.369f, 7.553f)
                curveTo(27.367f, 7.553f, 27.366f, 7.553f, 27.365f, 7.553f)
                curveTo(27.364f, 7.553f, 27.364f, 7.553f, 27.363f, 7.553f)
                curveTo(27.363f, 7.553f, 27.363f, 7.553f, 27.363f, 7.553f)
                curveTo(27.362f, 7.553f, 27.362f, 7.553f, 27.362f, 7.553f)
                curveTo(27.362f, 7.553f, 27.362f, 7.553f, 27.362f, 7.553f)
                curveTo(27.362f, 7.553f, 27.362f, 7.553f, 27.362f, 7.678f)
                curveTo(27.362f, 7.803f, 27.362f, 7.803f, 27.362f, 7.803f)
                curveTo(27.362f, 7.803f, 27.362f, 7.803f, 27.362f, 7.803f)
                curveTo(27.362f, 7.803f, 27.361f, 7.803f, 27.361f, 7.803f)
                curveTo(27.361f, 7.803f, 27.361f, 7.803f, 27.361f, 7.803f)
                curveTo(27.361f, 7.803f, 27.36f, 7.803f, 27.36f, 7.803f)
                curveTo(27.359f, 7.803f, 27.359f, 7.803f, 27.358f, 7.803f)
                curveTo(27.358f, 7.803f, 27.357f, 7.803f, 27.356f, 7.803f)
                curveTo(27.356f, 7.803f, 27.355f, 7.803f, 27.353f, 7.802f)
                curveTo(27.352f, 7.802f, 27.348f, 7.801f, 27.343f, 7.798f)
                curveTo(27.338f, 7.796f, 27.329f, 7.79f, 27.32f, 7.78f)
                curveTo(27.311f, 7.769f, 27.305f, 7.755f, 27.302f, 7.741f)
                curveTo(27.3f, 7.728f, 27.302f, 7.72f, 27.303f, 7.718f)
                curveTo(27.303f, 7.718f, 27.297f, 7.734f, 27.266f, 7.772f)
                lineTo(27.458f, 7.932f)
                close()
                moveTo(27.072f, 8.037f)
                curveTo(27.113f, 8.042f, 27.178f, 8.05f, 27.245f, 8.042f)
                curveTo(27.313f, 8.033f, 27.396f, 8.007f, 27.458f, 7.932f)
                lineTo(27.266f, 7.772f)
                curveTo(27.259f, 7.781f, 27.246f, 7.79f, 27.215f, 7.793f)
                curveTo(27.182f, 7.797f, 27.144f, 7.794f, 27.099f, 7.789f)
                lineTo(27.072f, 8.037f)
                close()
                moveTo(27.146f, 7.946f)
                curveTo(27.121f, 7.916f, 27.111f, 7.901f, 27.109f, 7.896f)
                curveTo(27.108f, 7.893f, 27.112f, 7.902f, 27.114f, 7.917f)
                curveTo(27.116f, 7.935f, 27.114f, 7.966f, 27.091f, 7.995f)
                curveTo(27.07f, 8.021f, 27.045f, 8.029f, 27.037f, 8.032f)
                curveTo(27.028f, 8.034f, 27.023f, 8.034f, 27.027f, 8.034f)
                curveTo(27.034f, 8.034f, 27.046f, 8.035f, 27.072f, 8.037f)
                lineTo(27.099f, 7.789f)
                curveTo(27.079f, 7.787f, 27.05f, 7.783f, 27.025f, 7.784f)
                curveTo(27.013f, 7.784f, 26.994f, 7.785f, 26.974f, 7.79f)
                curveTo(26.954f, 7.795f, 26.921f, 7.807f, 26.895f, 7.84f)
                curveTo(26.867f, 7.876f, 26.862f, 7.916f, 26.866f, 7.946f)
                curveTo(26.869f, 7.973f, 26.879f, 7.995f, 26.886f, 8.01f)
                curveTo(26.902f, 8.04f, 26.926f, 8.073f, 26.954f, 8.106f)
                lineTo(27.146f, 7.946f)
                close()
                moveTo(27.276f, 8.265f)
                curveTo(27.298f, 8.232f, 27.3f, 8.197f, 27.297f, 8.175f)
                curveTo(27.294f, 8.153f, 27.288f, 8.137f, 27.283f, 8.127f)
                curveTo(27.274f, 8.107f, 27.261f, 8.089f, 27.25f, 8.074f)
                curveTo(27.228f, 8.044f, 27.192f, 8.001f, 27.146f, 7.946f)
                lineTo(26.954f, 8.106f)
                curveTo(27.003f, 8.165f, 27.032f, 8.2f, 27.049f, 8.223f)
                curveTo(27.058f, 8.235f, 27.058f, 8.237f, 27.056f, 8.233f)
                curveTo(27.055f, 8.231f, 27.051f, 8.22f, 27.049f, 8.204f)
                curveTo(27.047f, 8.187f, 27.048f, 8.157f, 27.067f, 8.127f)
                lineTo(27.276f, 8.265f)
                close()
                moveTo(26.974f, 8.311f)
                curveTo(27.022f, 8.311f, 27.061f, 8.316f, 27.095f, 8.321f)
                curveTo(27.11f, 8.323f, 27.132f, 8.326f, 27.15f, 8.326f)
                curveTo(27.16f, 8.326f, 27.177f, 8.326f, 27.195f, 8.321f)
                curveTo(27.214f, 8.317f, 27.251f, 8.303f, 27.276f, 8.265f)
                lineTo(27.067f, 8.127f)
                curveTo(27.09f, 8.093f, 27.122f, 8.082f, 27.134f, 8.079f)
                curveTo(27.141f, 8.077f, 27.146f, 8.077f, 27.149f, 8.076f)
                curveTo(27.152f, 8.076f, 27.154f, 8.076f, 27.154f, 8.076f)
                curveTo(27.155f, 8.076f, 27.153f, 8.076f, 27.148f, 8.075f)
                curveTo(27.143f, 8.075f, 27.136f, 8.074f, 27.128f, 8.073f)
                curveTo(27.094f, 8.069f, 27.04f, 8.061f, 26.974f, 8.061f)
                verticalLineTo(8.311f)
                close()
                moveTo(26.615f, 8.231f)
                curveTo(26.722f, 8.267f, 26.85f, 8.311f, 26.974f, 8.311f)
                verticalLineTo(8.061f)
                curveTo(26.899f, 8.061f, 26.813f, 8.034f, 26.696f, 7.994f)
                lineTo(26.615f, 8.231f)
                close()
                moveTo(26.267f, 8.151f)
                curveTo(26.378f, 8.151f, 26.488f, 8.188f, 26.615f, 8.231f)
                lineTo(26.696f, 7.994f)
                curveTo(26.575f, 7.953f, 26.426f, 7.901f, 26.267f, 7.901f)
                verticalLineTo(8.151f)
                close()
                moveTo(26.486f, 8.158f)
                curveTo(26.447f, 8.135f, 26.405f, 8.11f, 26.366f, 8.085f)
                curveTo(26.326f, 8.059f, 26.297f, 8.037f, 26.281f, 8.021f)
                curveTo(26.272f, 8.013f, 26.274f, 8.013f, 26.278f, 8.021f)
                curveTo(26.283f, 8.031f, 26.299f, 8.071f, 26.273f, 8.115f)
                curveTo(26.252f, 8.15f, 26.221f, 8.156f, 26.227f, 8.154f)
                curveTo(26.229f, 8.154f, 26.241f, 8.151f, 26.267f, 8.151f)
                verticalLineTo(7.901f)
                curveTo(26.231f, 7.901f, 26.197f, 7.904f, 26.166f, 7.912f)
                curveTo(26.139f, 7.919f, 26.088f, 7.936f, 26.058f, 7.987f)
                curveTo(26.023f, 8.046f, 26.041f, 8.105f, 26.055f, 8.134f)
                curveTo(26.07f, 8.163f, 26.091f, 8.186f, 26.108f, 8.202f)
                curveTo(26.171f, 8.262f, 26.287f, 8.33f, 26.358f, 8.373f)
                lineTo(26.486f, 8.158f)
                close()
                moveTo(26.505f, 8.169f)
                curveTo(26.499f, 8.166f, 26.493f, 8.162f, 26.486f, 8.158f)
                lineTo(26.358f, 8.373f)
                curveTo(26.365f, 8.377f, 26.371f, 8.38f, 26.377f, 8.384f)
                lineTo(26.505f, 8.169f)
                close()
                moveTo(26.271f, 8.483f)
                curveTo(26.333f, 8.483f, 26.386f, 8.483f, 26.427f, 8.482f)
                curveTo(26.461f, 8.481f, 26.508f, 8.479f, 26.544f, 8.466f)
                curveTo(26.558f, 8.461f, 26.617f, 8.439f, 26.635f, 8.37f)
                curveTo(26.653f, 8.301f, 26.611f, 8.253f, 26.602f, 8.242f)
                curveTo(26.577f, 8.213f, 26.536f, 8.188f, 26.505f, 8.169f)
                lineTo(26.377f, 8.384f)
                curveTo(26.393f, 8.394f, 26.404f, 8.401f, 26.412f, 8.406f)
                curveTo(26.42f, 8.412f, 26.419f, 8.412f, 26.414f, 8.407f)
                curveTo(26.411f, 8.404f, 26.404f, 8.395f, 26.398f, 8.38f)
                curveTo(26.391f, 8.365f, 26.385f, 8.339f, 26.393f, 8.308f)
                curveTo(26.401f, 8.277f, 26.419f, 8.257f, 26.432f, 8.246f)
                curveTo(26.445f, 8.236f, 26.456f, 8.232f, 26.46f, 8.231f)
                curveTo(26.467f, 8.228f, 26.469f, 8.229f, 26.458f, 8.23f)
                curveTo(26.45f, 8.231f, 26.437f, 8.232f, 26.419f, 8.232f)
                curveTo(26.383f, 8.233f, 26.336f, 8.233f, 26.272f, 8.233f)
                lineTo(26.271f, 8.483f)
                close()
                moveTo(26.191f, 8.483f)
                curveTo(26.219f, 8.483f, 26.246f, 8.483f, 26.271f, 8.483f)
                lineTo(26.272f, 8.233f)
                curveTo(26.247f, 8.233f, 26.22f, 8.233f, 26.191f, 8.233f)
                verticalLineTo(8.483f)
                close()
                moveTo(25.887f, 8.459f)
                curveTo(25.936f, 8.468f, 26.027f, 8.483f, 26.191f, 8.483f)
                verticalLineTo(8.233f)
                curveTo(26.045f, 8.233f, 25.969f, 8.22f, 25.929f, 8.213f)
                lineTo(25.887f, 8.459f)
                close()
                moveTo(25.982f, 8.358f)
                curveTo(25.982f, 8.349f, 25.982f, 8.359f, 25.978f, 8.374f)
                curveTo(25.976f, 8.383f, 25.97f, 8.399f, 25.957f, 8.415f)
                curveTo(25.943f, 8.432f, 25.926f, 8.443f, 25.909f, 8.449f)
                curveTo(25.894f, 8.455f, 25.882f, 8.456f, 25.876f, 8.456f)
                curveTo(25.873f, 8.456f, 25.871f, 8.456f, 25.869f, 8.456f)
                curveTo(25.869f, 8.456f, 25.868f, 8.456f, 25.868f, 8.456f)
                curveTo(25.867f, 8.456f, 25.867f, 8.456f, 25.867f, 8.456f)
                curveTo(25.867f, 8.456f, 25.868f, 8.456f, 25.868f, 8.456f)
                curveTo(25.869f, 8.456f, 25.871f, 8.457f, 25.873f, 8.457f)
                curveTo(25.876f, 8.458f, 25.881f, 8.458f, 25.887f, 8.459f)
                lineTo(25.929f, 8.213f)
                curveTo(25.919f, 8.211f, 25.905f, 8.209f, 25.893f, 8.207f)
                curveTo(25.885f, 8.207f, 25.854f, 8.203f, 25.82f, 8.216f)
                curveTo(25.8f, 8.223f, 25.78f, 8.236f, 25.764f, 8.256f)
                curveTo(25.749f, 8.274f, 25.741f, 8.293f, 25.737f, 8.307f)
                curveTo(25.731f, 8.33f, 25.732f, 8.352f, 25.732f, 8.358f)
                horizontalLineTo(25.982f)
                close()
                moveTo(25.558f, 8.415f)
                curveTo(25.626f, 8.439f, 25.696f, 8.464f, 25.748f, 8.478f)
                curveTo(25.772f, 8.484f, 25.803f, 8.492f, 25.831f, 8.493f)
                curveTo(25.844f, 8.493f, 25.873f, 8.493f, 25.904f, 8.479f)
                curveTo(25.921f, 8.471f, 25.942f, 8.457f, 25.958f, 8.433f)
                curveTo(25.975f, 8.408f, 25.982f, 8.381f, 25.982f, 8.358f)
                horizontalLineTo(25.732f)
                curveTo(25.732f, 8.338f, 25.737f, 8.314f, 25.752f, 8.292f)
                curveTo(25.766f, 8.271f, 25.785f, 8.259f, 25.799f, 8.252f)
                curveTo(25.812f, 8.246f, 25.823f, 8.244f, 25.829f, 8.244f)
                curveTo(25.835f, 8.243f, 25.839f, 8.243f, 25.84f, 8.243f)
                curveTo(25.843f, 8.243f, 25.836f, 8.243f, 25.813f, 8.236f)
                curveTo(25.772f, 8.225f, 25.713f, 8.204f, 25.641f, 8.179f)
                lineTo(25.558f, 8.415f)
                close()
                moveTo(25.19f, 8.311f)
                curveTo(25.217f, 8.311f, 25.267f, 8.321f, 25.34f, 8.342f)
                curveTo(25.409f, 8.363f, 25.485f, 8.389f, 25.558f, 8.415f)
                lineTo(25.641f, 8.179f)
                curveTo(25.569f, 8.154f, 25.487f, 8.125f, 25.41f, 8.103f)
                curveTo(25.338f, 8.081f, 25.257f, 8.061f, 25.19f, 8.061f)
                verticalLineTo(8.311f)
                close()
                moveTo(25.578f, 8.504f)
                curveTo(25.639f, 8.395f, 25.639f, 8.395f, 25.639f, 8.395f)
                curveTo(25.639f, 8.395f, 25.639f, 8.395f, 25.639f, 8.395f)
                curveTo(25.639f, 8.395f, 25.639f, 8.395f, 25.639f, 8.395f)
                curveTo(25.639f, 8.395f, 25.639f, 8.395f, 25.639f, 8.395f)
                curveTo(25.638f, 8.395f, 25.638f, 8.395f, 25.637f, 8.394f)
                curveTo(25.636f, 8.394f, 25.635f, 8.393f, 25.633f, 8.392f)
                curveTo(25.629f, 8.39f, 25.623f, 8.386f, 25.616f, 8.382f)
                curveTo(25.601f, 8.374f, 25.58f, 8.362f, 25.555f, 8.347f)
                curveTo(25.505f, 8.318f, 25.442f, 8.279f, 25.385f, 8.241f)
                curveTo(25.324f, 8.201f, 25.282f, 8.168f, 25.265f, 8.151f)
                curveTo(25.262f, 8.147f, 25.264f, 8.149f, 25.268f, 8.155f)
                curveTo(25.27f, 8.159f, 25.285f, 8.187f, 25.277f, 8.226f)
                curveTo(25.266f, 8.275f, 25.23f, 8.298f, 25.211f, 8.306f)
                curveTo(25.195f, 8.312f, 25.185f, 8.311f, 25.19f, 8.311f)
                verticalLineTo(8.061f)
                curveTo(25.173f, 8.061f, 25.146f, 8.063f, 25.118f, 8.074f)
                curveTo(25.088f, 8.086f, 25.045f, 8.116f, 25.032f, 8.173f)
                curveTo(25.022f, 8.221f, 25.04f, 8.259f, 25.049f, 8.276f)
                curveTo(25.059f, 8.294f, 25.072f, 8.31f, 25.082f, 8.321f)
                curveTo(25.121f, 8.363f, 25.187f, 8.41f, 25.246f, 8.449f)
                curveTo(25.309f, 8.491f, 25.377f, 8.532f, 25.428f, 8.562f)
                curveTo(25.454f, 8.578f, 25.476f, 8.59f, 25.492f, 8.599f)
                curveTo(25.5f, 8.604f, 25.506f, 8.607f, 25.51f, 8.61f)
                curveTo(25.512f, 8.611f, 25.514f, 8.612f, 25.515f, 8.613f)
                curveTo(25.516f, 8.613f, 25.516f, 8.613f, 25.517f, 8.613f)
                curveTo(25.517f, 8.613f, 25.517f, 8.613f, 25.517f, 8.613f)
                curveTo(25.517f, 8.614f, 25.517f, 8.614f, 25.517f, 8.614f)
                curveTo(25.517f, 8.614f, 25.517f, 8.614f, 25.517f, 8.614f)
                curveTo(25.517f, 8.614f, 25.517f, 8.614f, 25.578f, 8.504f)
                close()
                moveTo(25.073f, 8.474f)
                curveTo(25.159f, 8.509f, 25.278f, 8.547f, 25.373f, 8.575f)
                curveTo(25.421f, 8.59f, 25.464f, 8.602f, 25.495f, 8.611f)
                curveTo(25.51f, 8.615f, 25.523f, 8.619f, 25.531f, 8.621f)
                curveTo(25.536f, 8.622f, 25.539f, 8.623f, 25.541f, 8.624f)
                curveTo(25.542f, 8.624f, 25.543f, 8.625f, 25.544f, 8.625f)
                curveTo(25.544f, 8.625f, 25.545f, 8.625f, 25.545f, 8.625f)
                curveTo(25.545f, 8.625f, 25.545f, 8.625f, 25.545f, 8.625f)
                curveTo(25.545f, 8.625f, 25.545f, 8.625f, 25.545f, 8.625f)
                curveTo(25.545f, 8.625f, 25.545f, 8.625f, 25.545f, 8.625f)
                curveTo(25.545f, 8.625f, 25.545f, 8.625f, 25.578f, 8.504f)
                curveTo(25.611f, 8.384f, 25.611f, 8.384f, 25.611f, 8.384f)
                curveTo(25.611f, 8.384f, 25.611f, 8.384f, 25.611f, 8.384f)
                curveTo(25.611f, 8.384f, 25.611f, 8.384f, 25.611f, 8.384f)
                curveTo(25.611f, 8.384f, 25.611f, 8.384f, 25.611f, 8.384f)
                curveTo(25.611f, 8.384f, 25.61f, 8.384f, 25.61f, 8.384f)
                curveTo(25.61f, 8.384f, 25.609f, 8.383f, 25.608f, 8.383f)
                curveTo(25.606f, 8.382f, 25.602f, 8.382f, 25.598f, 8.38f)
                curveTo(25.59f, 8.378f, 25.578f, 8.375f, 25.563f, 8.37f)
                curveTo(25.533f, 8.362f, 25.492f, 8.35f, 25.445f, 8.336f)
                curveTo(25.351f, 8.308f, 25.242f, 8.272f, 25.167f, 8.242f)
                lineTo(25.073f, 8.474f)
                close()
                moveTo(25.354f, 8.585f)
                curveTo(25.3f, 8.504f, 25.249f, 8.427f, 25.222f, 8.375f)
                curveTo(25.215f, 8.363f, 25.212f, 8.355f, 25.21f, 8.35f)
                curveTo(25.207f, 8.342f, 25.212f, 8.352f, 25.212f, 8.369f)
                curveTo(25.212f, 8.379f, 25.209f, 8.401f, 25.195f, 8.424f)
                curveTo(25.179f, 8.45f, 25.155f, 8.466f, 25.129f, 8.474f)
                curveTo(25.108f, 8.48f, 25.09f, 8.478f, 25.084f, 8.477f)
                curveTo(25.08f, 8.476f, 25.077f, 8.475f, 25.075f, 8.475f)
                curveTo(25.074f, 8.474f, 25.074f, 8.474f, 25.073f, 8.474f)
                curveTo(25.073f, 8.474f, 25.073f, 8.474f, 25.073f, 8.474f)
                lineTo(25.167f, 8.242f)
                curveTo(25.152f, 8.236f, 25.109f, 8.219f, 25.06f, 8.233f)
                curveTo(25.03f, 8.242f, 25.001f, 8.262f, 24.983f, 8.292f)
                curveTo(24.966f, 8.32f, 24.962f, 8.346f, 24.962f, 8.363f)
                curveTo(24.961f, 8.395f, 24.97f, 8.422f, 24.976f, 8.437f)
                curveTo(24.983f, 8.455f, 24.991f, 8.474f, 25f, 8.491f)
                curveTo(25.035f, 8.557f, 25.094f, 8.647f, 25.145f, 8.723f)
                lineTo(25.354f, 8.585f)
                close()
                moveTo(25.373f, 9.01f)
                curveTo(25.394f, 9.01f, 25.426f, 9.005f, 25.455f, 8.981f)
                curveTo(25.485f, 8.957f, 25.498f, 8.927f, 25.502f, 8.904f)
                curveTo(25.509f, 8.867f, 25.499f, 8.836f, 25.496f, 8.827f)
                curveTo(25.488f, 8.801f, 25.473f, 8.774f, 25.46f, 8.752f)
                curveTo(25.433f, 8.705f, 25.393f, 8.644f, 25.354f, 8.585f)
                lineTo(25.145f, 8.723f)
                curveTo(25.186f, 8.785f, 25.222f, 8.839f, 25.244f, 8.877f)
                curveTo(25.256f, 8.898f, 25.259f, 8.906f, 25.258f, 8.904f)
                curveTo(25.258f, 8.903f, 25.257f, 8.899f, 25.256f, 8.893f)
                curveTo(25.255f, 8.887f, 25.253f, 8.873f, 25.257f, 8.856f)
                curveTo(25.261f, 8.836f, 25.272f, 8.808f, 25.3f, 8.786f)
                curveTo(25.327f, 8.764f, 25.356f, 8.76f, 25.373f, 8.76f)
                verticalLineTo(9.01f)
                close()
                moveTo(25.199f, 8.958f)
                curveTo(25.226f, 8.969f, 25.255f, 8.981f, 25.281f, 8.99f)
                curveTo(25.3f, 8.997f, 25.337f, 9.01f, 25.373f, 9.01f)
                verticalLineTo(8.76f)
                curveTo(25.383f, 8.76f, 25.388f, 8.762f, 25.383f, 8.76f)
                curveTo(25.379f, 8.759f, 25.373f, 8.757f, 25.364f, 8.754f)
                curveTo(25.345f, 8.748f, 25.322f, 8.738f, 25.293f, 8.726f)
                lineTo(25.199f, 8.958f)
                close()
                moveTo(25.113f, 8.816f)
                curveTo(25.113f, 8.825f, 25.111f, 8.845f, 25.096f, 8.866f)
                curveTo(25.081f, 8.886f, 25.062f, 8.896f, 25.05f, 8.9f)
                curveTo(25.033f, 8.905f, 25.027f, 8.9f, 25.049f, 8.905f)
                curveTo(25.085f, 8.913f, 25.138f, 8.933f, 25.199f, 8.958f)
                lineTo(25.293f, 8.726f)
                curveTo(25.24f, 8.705f, 25.163f, 8.674f, 25.1f, 8.66f)
                curveTo(25.071f, 8.654f, 25.023f, 8.646f, 24.975f, 8.661f)
                curveTo(24.948f, 8.67f, 24.917f, 8.687f, 24.893f, 8.72f)
                curveTo(24.87f, 8.752f, 24.863f, 8.787f, 24.863f, 8.816f)
                horizontalLineTo(25.113f)
                close()
                moveTo(25.281f, 8.892f)
                curveTo(25.221f, 8.892f, 25.173f, 8.876f, 25.144f, 8.856f)
                curveTo(25.116f, 8.837f, 25.113f, 8.821f, 25.113f, 8.816f)
                horizontalLineTo(24.863f)
                curveTo(24.863f, 8.926f, 24.927f, 9.011f, 25.004f, 9.063f)
                curveTo(25.081f, 9.115f, 25.179f, 9.142f, 25.281f, 9.142f)
                verticalLineTo(8.892f)
                close()
                moveTo(25.373f, 9.323f)
                curveTo(25.443f, 9.323f, 25.503f, 9.286f, 25.534f, 9.225f)
                curveTo(25.56f, 9.172f, 25.557f, 9.114f, 25.542f, 9.068f)
                curveTo(25.51f, 8.971f, 25.414f, 8.892f, 25.281f, 8.892f)
                verticalLineTo(9.142f)
                curveTo(25.297f, 9.142f, 25.303f, 9.146f, 25.304f, 9.147f)
                curveTo(25.305f, 9.148f, 25.305f, 9.149f, 25.304f, 9.147f)
                curveTo(25.304f, 9.146f, 25.3f, 9.134f, 25.309f, 9.114f)
                curveTo(25.315f, 9.104f, 25.324f, 9.092f, 25.338f, 9.083f)
                curveTo(25.351f, 9.075f, 25.365f, 9.073f, 25.373f, 9.073f)
                verticalLineTo(9.323f)
                close()
                moveTo(25.225f, 9.294f)
                curveTo(25.258f, 9.304f, 25.318f, 9.323f, 25.373f, 9.323f)
                verticalLineTo(9.073f)
                curveTo(25.362f, 9.073f, 25.341f, 9.068f, 25.296f, 9.054f)
                lineTo(25.225f, 9.294f)
                close()
                moveTo(25.245f, 9.198f)
                curveTo(25.245f, 9.202f, 25.243f, 9.231f, 25.216f, 9.255f)
                curveTo(25.192f, 9.278f, 25.167f, 9.279f, 25.165f, 9.279f)
                curveTo(25.162f, 9.279f, 25.166f, 9.278f, 25.179f, 9.282f)
                curveTo(25.192f, 9.284f, 25.206f, 9.289f, 25.225f, 9.294f)
                lineTo(25.296f, 9.054f)
                curveTo(25.267f, 9.046f, 25.21f, 9.028f, 25.161f, 9.029f)
                curveTo(25.133f, 9.029f, 25.086f, 9.035f, 25.046f, 9.072f)
                curveTo(25.005f, 9.111f, 24.995f, 9.161f, 24.995f, 9.198f)
                horizontalLineTo(25.245f)
                close()
                moveTo(25.274f, 9.223f)
                curveTo(25.265f, 9.214f, 25.259f, 9.207f, 25.253f, 9.2f)
                curveTo(25.248f, 9.194f, 25.245f, 9.19f, 25.243f, 9.187f)
                curveTo(25.242f, 9.185f, 25.242f, 9.185f, 25.243f, 9.187f)
                curveTo(25.244f, 9.19f, 25.245f, 9.194f, 25.245f, 9.198f)
                horizontalLineTo(24.995f)
                curveTo(24.995f, 9.297f, 25.065f, 9.365f, 25.089f, 9.392f)
                lineTo(25.274f, 9.223f)
                close()
                moveTo(25.406f, 9.525f)
                curveTo(25.406f, 9.365f, 25.321f, 9.275f, 25.274f, 9.223f)
                lineTo(25.089f, 9.392f)
                curveTo(25.113f, 9.418f, 25.128f, 9.435f, 25.139f, 9.455f)
                curveTo(25.148f, 9.472f, 25.156f, 9.493f, 25.156f, 9.525f)
                horizontalLineTo(25.406f)
                close()
                moveTo(25.014f, 9.548f)
                curveTo(24.987f, 9.59f, 24.947f, 9.687f, 25.021f, 9.765f)
                curveTo(25.082f, 9.83f, 25.167f, 9.818f, 25.206f, 9.807f)
                curveTo(25.304f, 9.778f, 25.406f, 9.679f, 25.406f, 9.525f)
                horizontalLineTo(25.156f)
                curveTo(25.156f, 9.544f, 25.15f, 9.553f, 25.146f, 9.558f)
                curveTo(25.144f, 9.561f, 25.142f, 9.563f, 25.139f, 9.565f)
                curveTo(25.137f, 9.566f, 25.135f, 9.567f, 25.136f, 9.567f)
                curveTo(25.136f, 9.567f, 25.138f, 9.566f, 25.14f, 9.566f)
                curveTo(25.142f, 9.566f, 25.146f, 9.566f, 25.151f, 9.566f)
                curveTo(25.16f, 9.567f, 25.182f, 9.572f, 25.203f, 9.593f)
                curveTo(25.225f, 9.617f, 25.23f, 9.646f, 25.229f, 9.665f)
                curveTo(25.227f, 9.681f, 25.222f, 9.687f, 25.226f, 9.682f)
                lineTo(25.014f, 9.548f)
                close()
                moveTo(24.972f, 9.337f)
                curveTo(24.972f, 9.341f, 24.97f, 9.383f, 24.926f, 9.41f)
                curveTo(24.907f, 9.421f, 24.89f, 9.423f, 24.881f, 9.423f)
                curveTo(24.871f, 9.423f, 24.866f, 9.421f, 24.865f, 9.421f)
                curveTo(24.865f, 9.421f, 24.872f, 9.424f, 24.886f, 9.432f)
                curveTo(24.898f, 9.441f, 24.913f, 9.452f, 24.928f, 9.466f)
                curveTo(24.96f, 9.495f, 24.986f, 9.528f, 24.999f, 9.555f)
                curveTo(25.016f, 9.588f, 24.997f, 9.575f, 25.014f, 9.548f)
                lineTo(25.226f, 9.682f)
                curveTo(25.282f, 9.592f, 25.249f, 9.495f, 25.222f, 9.442f)
                curveTo(25.191f, 9.382f, 25.144f, 9.326f, 25.098f, 9.283f)
                curveTo(25.054f, 9.242f, 24.995f, 9.199f, 24.937f, 9.182f)
                curveTo(24.909f, 9.173f, 24.853f, 9.162f, 24.798f, 9.195f)
                curveTo(24.735f, 9.232f, 24.722f, 9.297f, 24.722f, 9.337f)
                horizontalLineTo(24.972f)
                close()
                moveTo(24.972f, 9.525f)
                verticalLineTo(9.337f)
                horizontalLineTo(24.722f)
                verticalLineTo(9.525f)
                horizontalLineTo(24.972f)
                close()
                moveTo(24.803f, 9.799f)
                curveTo(24.821f, 9.795f, 24.888f, 9.78f, 24.93f, 9.716f)
                curveTo(24.966f, 9.662f, 24.972f, 9.592f, 24.972f, 9.525f)
                horizontalLineTo(24.722f)
                curveTo(24.722f, 9.554f, 24.721f, 9.571f, 24.719f, 9.581f)
                curveTo(24.717f, 9.59f, 24.716f, 9.586f, 24.722f, 9.578f)
                curveTo(24.725f, 9.573f, 24.729f, 9.568f, 24.734f, 9.564f)
                curveTo(24.739f, 9.56f, 24.743f, 9.557f, 24.746f, 9.556f)
                curveTo(24.749f, 9.555f, 24.75f, 9.555f, 24.748f, 9.555f)
                curveTo(24.745f, 9.556f, 24.743f, 9.557f, 24.736f, 9.559f)
                lineTo(24.803f, 9.799f)
                close()
                moveTo(24.758f, 9.824f)
                curveTo(24.767f, 9.814f, 24.774f, 9.81f, 24.778f, 9.808f)
                curveTo(24.783f, 9.805f, 24.788f, 9.804f, 24.803f, 9.799f)
                lineTo(24.736f, 9.559f)
                curveTo(24.7f, 9.569f, 24.637f, 9.586f, 24.575f, 9.654f)
                lineTo(24.758f, 9.824f)
                close()
                moveTo(24.716f, 9.887f)
                curveTo(24.717f, 9.88f, 24.718f, 9.878f, 24.721f, 9.872f)
                curveTo(24.725f, 9.865f, 24.734f, 9.849f, 24.758f, 9.824f)
                lineTo(24.575f, 9.654f)
                curveTo(24.54f, 9.691f, 24.516f, 9.725f, 24.5f, 9.756f)
                curveTo(24.483f, 9.788f, 24.476f, 9.814f, 24.473f, 9.827f)
                lineTo(24.716f, 9.887f)
                close()
                moveTo(24.547f, 10.006f)
                curveTo(24.558f, 10.006f, 24.572f, 10.006f, 24.586f, 10.004f)
                curveTo(24.599f, 10.002f, 24.623f, 9.999f, 24.648f, 9.984f)
                curveTo(24.677f, 9.967f, 24.695f, 9.942f, 24.705f, 9.92f)
                curveTo(24.712f, 9.904f, 24.715f, 9.888f, 24.716f, 9.887f)
                lineTo(24.473f, 9.827f)
                curveTo(24.471f, 9.836f, 24.472f, 9.827f, 24.477f, 9.818f)
                curveTo(24.484f, 9.802f, 24.497f, 9.782f, 24.521f, 9.768f)
                curveTo(24.54f, 9.757f, 24.556f, 9.756f, 24.556f, 9.756f)
                curveTo(24.558f, 9.756f, 24.556f, 9.756f, 24.547f, 9.756f)
                verticalLineTo(10.006f)
                close()
                moveTo(24.345f, 9.853f)
                curveTo(24.362f, 9.878f, 24.384f, 9.911f, 24.407f, 9.937f)
                curveTo(24.428f, 9.96f, 24.475f, 10.006f, 24.547f, 10.006f)
                verticalLineTo(9.756f)
                curveTo(24.566f, 9.756f, 24.581f, 9.762f, 24.588f, 9.767f)
                curveTo(24.594f, 9.771f, 24.596f, 9.773f, 24.593f, 9.77f)
                curveTo(24.59f, 9.766f, 24.585f, 9.76f, 24.578f, 9.75f)
                curveTo(24.571f, 9.74f, 24.563f, 9.729f, 24.554f, 9.715f)
                lineTo(24.345f, 9.853f)
                close()
                moveTo(24.118f, 9.643f)
                curveTo(24.229f, 9.682f, 24.288f, 9.766f, 24.345f, 9.853f)
                lineTo(24.554f, 9.715f)
                curveTo(24.498f, 9.63f, 24.399f, 9.477f, 24.201f, 9.407f)
                lineTo(24.118f, 9.643f)
                close()
                moveTo(24.113f, 9.601f)
                curveTo(24.115f, 9.592f, 24.116f, 9.587f, 24.117f, 9.583f)
                curveTo(24.118f, 9.579f, 24.118f, 9.579f, 24.117f, 9.581f)
                curveTo(24.116f, 9.583f, 24.113f, 9.59f, 24.107f, 9.597f)
                curveTo(24.1f, 9.605f, 24.091f, 9.613f, 24.08f, 9.618f)
                curveTo(24.06f, 9.628f, 24.047f, 9.625f, 24.057f, 9.626f)
                curveTo(24.066f, 9.627f, 24.084f, 9.631f, 24.118f, 9.643f)
                lineTo(24.201f, 9.407f)
                curveTo(24.16f, 9.393f, 24.123f, 9.382f, 24.088f, 9.378f)
                curveTo(24.055f, 9.374f, 24.011f, 9.374f, 23.969f, 9.395f)
                curveTo(23.922f, 9.418f, 23.899f, 9.456f, 23.886f, 9.485f)
                curveTo(23.876f, 9.51f, 23.871f, 9.538f, 23.868f, 9.55f)
                lineTo(24.113f, 9.601f)
                close()
                moveTo(23.965f, 9.841f)
                curveTo(24.081f, 9.759f, 24.102f, 9.654f, 24.113f, 9.601f)
                lineTo(23.868f, 9.55f)
                curveTo(23.863f, 9.575f, 23.86f, 9.588f, 23.854f, 9.601f)
                curveTo(23.849f, 9.611f, 23.841f, 9.623f, 23.821f, 9.637f)
                lineTo(23.965f, 9.841f)
                close()
                moveTo(23.94f, 9.805f)
                curveTo(23.935f, 9.799f, 23.932f, 9.797f, 23.93f, 9.794f)
                curveTo(23.928f, 9.792f, 23.928f, 9.792f, 23.93f, 9.793f)
                curveTo(23.932f, 9.798f, 23.942f, 9.814f, 23.94f, 9.838f)
                curveTo(23.938f, 9.861f, 23.928f, 9.873f, 23.93f, 9.87f)
                curveTo(23.933f, 9.867f, 23.942f, 9.858f, 23.965f, 9.841f)
                lineTo(23.821f, 9.637f)
                curveTo(23.788f, 9.66f, 23.76f, 9.684f, 23.737f, 9.711f)
                curveTo(23.715f, 9.738f, 23.694f, 9.775f, 23.691f, 9.821f)
                curveTo(23.687f, 9.868f, 23.704f, 9.905f, 23.72f, 9.929f)
                curveTo(23.733f, 9.951f, 23.751f, 9.969f, 23.758f, 9.976f)
                lineTo(23.94f, 9.805f)
                close()
                moveTo(24.018f, 9.973f)
                curveTo(24.018f, 9.88f, 23.956f, 9.821f, 23.94f, 9.805f)
                lineTo(23.758f, 9.976f)
                curveTo(23.764f, 9.982f, 23.767f, 9.986f, 23.77f, 9.989f)
                curveTo(23.772f, 9.992f, 23.773f, 9.993f, 23.773f, 9.993f)
                curveTo(23.773f, 9.993f, 23.771f, 9.99f, 23.77f, 9.986f)
                curveTo(23.769f, 9.982f, 23.768f, 9.978f, 23.768f, 9.973f)
                horizontalLineTo(24.018f)
                close()
                moveTo(23.572f, 9.739f)
                curveTo(23.572f, 9.8f, 23.594f, 9.858f, 23.616f, 9.903f)
                curveTo(23.64f, 9.95f, 23.671f, 9.993f, 23.702f, 10.028f)
                curveTo(23.73f, 10.058f, 23.771f, 10.097f, 23.819f, 10.115f)
                curveTo(23.842f, 10.123f, 23.901f, 10.139f, 23.957f, 10.099f)
                curveTo(24.013f, 10.059f, 24.018f, 9.999f, 24.018f, 9.973f)
                horizontalLineTo(23.768f)
                curveTo(23.768f, 9.972f, 23.767f, 9.927f, 23.812f, 9.895f)
                curveTo(23.858f, 9.863f, 23.901f, 9.879f, 23.906f, 9.88f)
                curveTo(23.917f, 9.884f, 23.909f, 9.884f, 23.888f, 9.86f)
                curveTo(23.87f, 9.84f, 23.852f, 9.815f, 23.839f, 9.79f)
                curveTo(23.825f, 9.762f, 23.822f, 9.745f, 23.822f, 9.739f)
                horizontalLineTo(23.572f)
                close()
                moveTo(23.599f, 9.525f)
                curveTo(23.599f, 9.533f, 23.597f, 9.573f, 23.556f, 9.602f)
                curveTo(23.52f, 9.628f, 23.485f, 9.62f, 23.48f, 9.619f)
                curveTo(23.471f, 9.617f, 23.48f, 9.617f, 23.503f, 9.638f)
                curveTo(23.522f, 9.655f, 23.542f, 9.678f, 23.556f, 9.7f)
                curveTo(23.562f, 9.711f, 23.567f, 9.72f, 23.569f, 9.728f)
                curveTo(23.572f, 9.736f, 23.572f, 9.739f, 23.572f, 9.739f)
                horizontalLineTo(23.822f)
                curveTo(23.822f, 9.673f, 23.796f, 9.614f, 23.769f, 9.57f)
                curveTo(23.741f, 9.524f, 23.705f, 9.482f, 23.668f, 9.45f)
                curveTo(23.636f, 9.422f, 23.589f, 9.388f, 23.538f, 9.376f)
                curveTo(23.512f, 9.37f, 23.46f, 9.363f, 23.411f, 9.398f)
                curveTo(23.359f, 9.436f, 23.349f, 9.492f, 23.349f, 9.525f)
                horizontalLineTo(23.599f)
                close()
                moveTo(23.36f, 9.864f)
                curveTo(23.41f, 9.864f, 23.46f, 9.851f, 23.502f, 9.819f)
                curveTo(23.543f, 9.787f, 23.565f, 9.746f, 23.578f, 9.71f)
                curveTo(23.601f, 9.645f, 23.599f, 9.568f, 23.599f, 9.525f)
                horizontalLineTo(23.349f)
                curveTo(23.349f, 9.551f, 23.349f, 9.572f, 23.348f, 9.591f)
                curveTo(23.346f, 9.611f, 23.344f, 9.622f, 23.342f, 9.628f)
                curveTo(23.34f, 9.633f, 23.341f, 9.627f, 23.35f, 9.62f)
                curveTo(23.36f, 9.613f, 23.367f, 9.614f, 23.36f, 9.614f)
                verticalLineTo(9.864f)
                close()
                moveTo(23.424f, 9.824f)
                curveTo(23.425f, 9.812f, 23.426f, 9.807f, 23.426f, 9.805f)
                curveTo(23.426f, 9.802f, 23.426f, 9.811f, 23.419f, 9.822f)
                curveTo(23.411f, 9.836f, 23.398f, 9.85f, 23.381f, 9.858f)
                curveTo(23.367f, 9.864f, 23.357f, 9.864f, 23.36f, 9.864f)
                verticalLineTo(9.614f)
                curveTo(23.334f, 9.614f, 23.304f, 9.618f, 23.274f, 9.632f)
                curveTo(23.241f, 9.648f, 23.217f, 9.672f, 23.201f, 9.7f)
                curveTo(23.187f, 9.726f, 23.181f, 9.751f, 23.179f, 9.767f)
                curveTo(23.176f, 9.783f, 23.176f, 9.799f, 23.175f, 9.809f)
                lineTo(23.424f, 9.824f)
                close()
                moveTo(23.29f, 10.078f)
                curveTo(23.348f, 10.04f, 23.383f, 9.991f, 23.403f, 9.939f)
                curveTo(23.421f, 9.892f, 23.423f, 9.847f, 23.424f, 9.824f)
                lineTo(23.175f, 9.809f)
                curveTo(23.173f, 9.835f, 23.172f, 9.844f, 23.169f, 9.851f)
                curveTo(23.168f, 9.853f, 23.167f, 9.855f, 23.166f, 9.857f)
                curveTo(23.164f, 9.859f, 23.16f, 9.863f, 23.152f, 9.869f)
                lineTo(23.29f, 10.078f)
                close()
                moveTo(23.03f, 9.933f)
                curveTo(23.03f, 9.943f, 23.028f, 9.963f, 23.029f, 9.981f)
                curveTo(23.03f, 9.991f, 23.031f, 10.006f, 23.036f, 10.023f)
                curveTo(23.041f, 10.04f, 23.052f, 10.066f, 23.077f, 10.088f)
                curveTo(23.134f, 10.139f, 23.201f, 10.12f, 23.221f, 10.113f)
                curveTo(23.246f, 10.105f, 23.27f, 10.09f, 23.29f, 10.078f)
                lineTo(23.152f, 9.869f)
                curveTo(23.136f, 9.879f, 23.134f, 9.879f, 23.14f, 9.877f)
                curveTo(23.14f, 9.877f, 23.194f, 9.857f, 23.243f, 9.901f)
                curveTo(23.264f, 9.92f, 23.272f, 9.941f, 23.275f, 9.951f)
                curveTo(23.279f, 9.961f, 23.279f, 9.968f, 23.279f, 9.969f)
                curveTo(23.279f, 9.969f, 23.279f, 9.968f, 23.279f, 9.964f)
                curveTo(23.279f, 9.96f, 23.279f, 9.955f, 23.28f, 9.948f)
                lineTo(23.03f, 9.933f)
                close()
                moveTo(23.01f, 9.816f)
                curveTo(23.033f, 9.845f, 23.034f, 9.878f, 23.03f, 9.933f)
                lineTo(23.28f, 9.948f)
                curveTo(23.283f, 9.898f, 23.294f, 9.773f, 23.206f, 9.662f)
                lineTo(23.01f, 9.816f)
                close()
                moveTo(23.011f, 9.398f)
                curveTo(22.997f, 9.431f, 22.969f, 9.495f, 22.957f, 9.564f)
                curveTo(22.945f, 9.633f, 22.944f, 9.732f, 23.01f, 9.816f)
                lineTo(23.206f, 9.662f)
                curveTo(23.204f, 9.659f, 23.197f, 9.646f, 23.203f, 9.608f)
                curveTo(23.21f, 9.57f, 23.226f, 9.532f, 23.241f, 9.496f)
                lineTo(23.011f, 9.398f)
                close()
                moveTo(23.191f, 9.519f)
                curveTo(23.203f, 9.509f, 23.203f, 9.509f, 23.198f, 9.512f)
                curveTo(23.196f, 9.513f, 23.192f, 9.516f, 23.186f, 9.519f)
                curveTo(23.181f, 9.521f, 23.168f, 9.526f, 23.152f, 9.528f)
                curveTo(23.134f, 9.53f, 23.103f, 9.529f, 23.072f, 9.509f)
                curveTo(23.04f, 9.489f, 23.026f, 9.459f, 23.02f, 9.439f)
                curveTo(23.015f, 9.42f, 23.016f, 9.405f, 23.016f, 9.398f)
                curveTo(23.017f, 9.391f, 23.018f, 9.385f, 23.018f, 9.383f)
                curveTo(23.02f, 9.377f, 23.021f, 9.375f, 23.02f, 9.377f)
                curveTo(23.019f, 9.38f, 23.016f, 9.386f, 23.011f, 9.398f)
                lineTo(23.241f, 9.496f)
                curveTo(23.245f, 9.486f, 23.251f, 9.473f, 23.255f, 9.463f)
                curveTo(23.257f, 9.457f, 23.26f, 9.448f, 23.262f, 9.439f)
                curveTo(23.263f, 9.435f, 23.271f, 9.405f, 23.261f, 9.371f)
                curveTo(23.255f, 9.35f, 23.24f, 9.319f, 23.207f, 9.298f)
                curveTo(23.175f, 9.278f, 23.143f, 9.277f, 23.125f, 9.279f)
                curveTo(23.093f, 9.283f, 23.07f, 9.297f, 23.066f, 9.3f)
                curveTo(23.051f, 9.31f, 23.036f, 9.323f, 23.025f, 9.332f)
                lineTo(23.191f, 9.519f)
                close()
                moveTo(22.759f, 9.65f)
                curveTo(22.85f, 9.65f, 23.04f, 9.654f, 23.191f, 9.519f)
                lineTo(23.025f, 9.332f)
                curveTo(22.954f, 9.396f, 22.86f, 9.4f, 22.759f, 9.4f)
                lineTo(22.759f, 9.65f)
                close()
                moveTo(22.755f, 9.65f)
                horizontalLineTo(22.759f)
                verticalLineTo(9.4f)
                horizontalLineTo(22.755f)
                verticalLineTo(9.65f)
                close()
                moveTo(22.732f, 9.693f)
                curveTo(22.739f, 9.683f, 22.746f, 9.675f, 22.753f, 9.667f)
                curveTo(22.76f, 9.66f, 22.765f, 9.654f, 22.77f, 9.65f)
                curveTo(22.774f, 9.646f, 22.776f, 9.645f, 22.775f, 9.646f)
                curveTo(22.773f, 9.647f, 22.766f, 9.65f, 22.755f, 9.65f)
                verticalLineTo(9.4f)
                curveTo(22.686f, 9.4f, 22.635f, 9.436f, 22.606f, 9.461f)
                curveTo(22.576f, 9.487f, 22.552f, 9.518f, 22.538f, 9.535f)
                lineTo(22.732f, 9.693f)
                close()
                moveTo(22.462f, 9.615f)
                curveTo(22.462f, 9.63f, 22.462f, 9.66f, 22.474f, 9.689f)
                curveTo(22.48f, 9.705f, 22.496f, 9.737f, 22.534f, 9.758f)
                curveTo(22.575f, 9.782f, 22.617f, 9.776f, 22.641f, 9.767f)
                curveTo(22.663f, 9.759f, 22.679f, 9.747f, 22.686f, 9.741f)
                curveTo(22.694f, 9.735f, 22.701f, 9.727f, 22.706f, 9.722f)
                curveTo(22.715f, 9.712f, 22.725f, 9.701f, 22.732f, 9.693f)
                lineTo(22.538f, 9.535f)
                curveTo(22.529f, 9.545f, 22.526f, 9.549f, 22.523f, 9.552f)
                curveTo(22.522f, 9.553f, 22.524f, 9.551f, 22.527f, 9.549f)
                curveTo(22.529f, 9.547f, 22.54f, 9.538f, 22.558f, 9.531f)
                curveTo(22.579f, 9.524f, 22.617f, 9.518f, 22.655f, 9.54f)
                curveTo(22.689f, 9.559f, 22.703f, 9.588f, 22.707f, 9.598f)
                curveTo(22.714f, 9.617f, 22.712f, 9.628f, 22.712f, 9.615f)
                horizontalLineTo(22.462f)
                close()
                moveTo(22.997f, 9.073f)
                curveTo(22.811f, 9.073f, 22.676f, 9.178f, 22.593f, 9.287f)
                curveTo(22.551f, 9.342f, 22.519f, 9.401f, 22.497f, 9.455f)
                curveTo(22.477f, 9.508f, 22.462f, 9.565f, 22.462f, 9.615f)
                horizontalLineTo(22.712f)
                curveTo(22.712f, 9.607f, 22.716f, 9.583f, 22.73f, 9.547f)
                curveTo(22.743f, 9.512f, 22.764f, 9.474f, 22.791f, 9.439f)
                curveTo(22.845f, 9.368f, 22.915f, 9.323f, 22.997f, 9.323f)
                verticalLineTo(9.073f)
                close()
                moveTo(23.326f, 8.963f)
                curveTo(23.244f, 9.019f, 23.166f, 9.073f, 22.997f, 9.073f)
                verticalLineTo(9.323f)
                curveTo(23.241f, 9.323f, 23.37f, 9.236f, 23.466f, 9.17f)
                lineTo(23.326f, 8.963f)
                close()
                moveTo(23.415f, 8.907f)
                curveTo(23.382f, 8.925f, 23.351f, 8.946f, 23.326f, 8.963f)
                lineTo(23.466f, 9.17f)
                curveTo(23.494f, 9.151f, 23.514f, 9.138f, 23.534f, 9.127f)
                lineTo(23.415f, 8.907f)
                close()
                moveTo(23.302f, 8.927f)
                curveTo(23.329f, 8.94f, 23.353f, 8.954f, 23.372f, 8.967f)
                curveTo(23.393f, 8.981f, 23.403f, 8.991f, 23.406f, 8.994f)
                curveTo(23.41f, 8.999f, 23.391f, 8.979f, 23.398f, 8.942f)
                curveTo(23.406f, 8.907f, 23.43f, 8.899f, 23.415f, 8.907f)
                lineTo(23.534f, 9.127f)
                curveTo(23.576f, 9.105f, 23.628f, 9.064f, 23.643f, 8.994f)
                curveTo(23.658f, 8.923f, 23.624f, 8.867f, 23.6f, 8.837f)
                curveTo(23.553f, 8.779f, 23.473f, 8.734f, 23.417f, 8.705f)
                lineTo(23.302f, 8.927f)
                close()
                moveTo(23.249f, 8.571f)
                curveTo(23.228f, 8.616f, 23.208f, 8.673f, 23.203f, 8.729f)
                curveTo(23.199f, 8.782f, 23.209f, 8.878f, 23.302f, 8.927f)
                lineTo(23.417f, 8.705f)
                curveTo(23.424f, 8.708f, 23.432f, 8.714f, 23.438f, 8.721f)
                curveTo(23.444f, 8.728f, 23.448f, 8.736f, 23.45f, 8.741f)
                curveTo(23.454f, 8.751f, 23.452f, 8.755f, 23.453f, 8.749f)
                curveTo(23.453f, 8.743f, 23.455f, 8.734f, 23.459f, 8.72f)
                curveTo(23.463f, 8.707f, 23.469f, 8.692f, 23.476f, 8.677f)
                lineTo(23.249f, 8.571f)
                close()
                moveTo(23.422f, 8.734f)
                curveTo(23.46f, 8.713f, 23.5f, 8.687f, 23.531f, 8.655f)
                curveTo(23.561f, 8.625f, 23.599f, 8.573f, 23.599f, 8.504f)
                horizontalLineTo(23.349f)
                curveTo(23.349f, 8.491f, 23.353f, 8.482f, 23.355f, 8.478f)
                curveTo(23.357f, 8.475f, 23.357f, 8.476f, 23.353f, 8.48f)
                curveTo(23.345f, 8.488f, 23.329f, 8.5f, 23.303f, 8.514f)
                lineTo(23.422f, 8.734f)
                close()
                moveTo(23.599f, 8.504f)
                curveTo(23.599f, 8.49f, 23.598f, 8.453f, 23.573f, 8.418f)
                curveTo(23.559f, 8.397f, 23.537f, 8.379f, 23.508f, 8.369f)
                curveTo(23.481f, 8.36f, 23.456f, 8.361f, 23.438f, 8.365f)
                curveTo(23.406f, 8.372f, 23.383f, 8.388f, 23.374f, 8.396f)
                curveTo(23.361f, 8.405f, 23.35f, 8.416f, 23.342f, 8.426f)
                curveTo(23.309f, 8.462f, 23.275f, 8.517f, 23.249f, 8.571f)
                lineTo(23.476f, 8.677f)
                curveTo(23.494f, 8.638f, 23.515f, 8.606f, 23.528f, 8.593f)
                curveTo(23.53f, 8.59f, 23.53f, 8.591f, 23.527f, 8.593f)
                curveTo(23.527f, 8.593f, 23.513f, 8.605f, 23.488f, 8.61f)
                curveTo(23.473f, 8.613f, 23.452f, 8.614f, 23.427f, 8.606f)
                curveTo(23.401f, 8.597f, 23.382f, 8.581f, 23.369f, 8.563f)
                curveTo(23.348f, 8.533f, 23.349f, 8.505f, 23.349f, 8.504f)
                horizontalLineTo(23.599f)
                close()
                moveTo(23.108f, 8.825f)
                curveTo(23.199f, 8.825f, 23.328f, 8.785f, 23.422f, 8.734f)
                lineTo(23.303f, 8.514f)
                curveTo(23.233f, 8.552f, 23.145f, 8.575f, 23.108f, 8.575f)
                verticalLineTo(8.825f)
                close()
                moveTo(23.018f, 8.443f)
                curveTo(22.996f, 8.496f, 22.968f, 8.561f, 22.958f, 8.613f)
                curveTo(22.953f, 8.636f, 22.945f, 8.683f, 22.964f, 8.73f)
                curveTo(22.975f, 8.758f, 22.995f, 8.785f, 23.026f, 8.803f)
                curveTo(23.056f, 8.821f, 23.085f, 8.825f, 23.108f, 8.825f)
                verticalLineTo(8.575f)
                curveTo(23.116f, 8.575f, 23.133f, 8.576f, 23.153f, 8.588f)
                curveTo(23.175f, 8.601f, 23.189f, 8.62f, 23.195f, 8.637f)
                curveTo(23.202f, 8.652f, 23.202f, 8.663f, 23.202f, 8.666f)
                curveTo(23.202f, 8.669f, 23.201f, 8.669f, 23.202f, 8.664f)
                curveTo(23.204f, 8.655f, 23.209f, 8.639f, 23.218f, 8.616f)
                curveTo(23.226f, 8.593f, 23.237f, 8.567f, 23.249f, 8.537f)
                lineTo(23.018f, 8.443f)
                close()
                moveTo(23.096f, 8.186f)
                curveTo(23.096f, 8.212f, 23.089f, 8.248f, 23.073f, 8.296f)
                curveTo(23.058f, 8.343f, 23.038f, 8.392f, 23.018f, 8.443f)
                lineTo(23.249f, 8.537f)
                curveTo(23.269f, 8.489f, 23.293f, 8.431f, 23.311f, 8.373f)
                curveTo(23.33f, 8.316f, 23.346f, 8.25f, 23.346f, 8.186f)
                horizontalLineTo(23.096f)
                close()
                moveTo(23.128f, 7.947f)
                curveTo(23.116f, 7.998f, 23.096f, 8.085f, 23.096f, 8.186f)
                horizontalLineTo(23.346f)
                curveTo(23.346f, 8.116f, 23.36f, 8.054f, 23.372f, 8.002f)
                lineTo(23.128f, 7.947f)
                close()
                moveTo(23.294f, 8.017f)
                curveTo(23.298f, 8.014f, 23.299f, 8.014f, 23.297f, 8.015f)
                curveTo(23.297f, 8.015f, 23.289f, 8.02f, 23.275f, 8.023f)
                curveTo(23.261f, 8.025f, 23.227f, 8.03f, 23.192f, 8.008f)
                curveTo(23.155f, 7.986f, 23.143f, 7.953f, 23.139f, 7.938f)
                curveTo(23.135f, 7.922f, 23.135f, 7.912f, 23.136f, 7.91f)
                curveTo(23.136f, 7.908f, 23.136f, 7.908f, 23.135f, 7.911f)
                curveTo(23.134f, 7.919f, 23.132f, 7.929f, 23.128f, 7.947f)
                lineTo(23.372f, 8.002f)
                curveTo(23.375f, 7.987f, 23.379f, 7.969f, 23.382f, 7.953f)
                curveTo(23.383f, 7.944f, 23.39f, 7.91f, 23.381f, 7.876f)
                curveTo(23.375f, 7.855f, 23.36f, 7.818f, 23.32f, 7.794f)
                curveTo(23.281f, 7.77f, 23.242f, 7.774f, 23.222f, 7.778f)
                curveTo(23.188f, 7.785f, 23.16f, 7.805f, 23.149f, 7.814f)
                lineTo(23.294f, 8.017f)
                close()
                moveTo(22.583f, 8.002f)
                curveTo(22.696f, 8.018f, 22.838f, 8.039f, 22.961f, 8.05f)
                curveTo(23.023f, 8.056f, 23.083f, 8.059f, 23.133f, 8.058f)
                curveTo(23.158f, 8.057f, 23.184f, 8.055f, 23.208f, 8.051f)
                curveTo(23.23f, 8.047f, 23.263f, 8.039f, 23.294f, 8.017f)
                lineTo(23.149f, 7.814f)
                curveTo(23.163f, 7.803f, 23.173f, 7.803f, 23.163f, 7.805f)
                curveTo(23.156f, 7.806f, 23.145f, 7.808f, 23.126f, 7.808f)
                curveTo(23.09f, 7.809f, 23.042f, 7.806f, 22.984f, 7.801f)
                curveTo(22.869f, 7.791f, 22.734f, 7.771f, 22.62f, 7.754f)
                lineTo(22.583f, 8.002f)
                close()
                moveTo(22.399f, 7.977f)
                curveTo(22.399f, 7.977f, 22.4f, 7.977f, 22.403f, 7.978f)
                curveTo(22.407f, 7.978f, 22.411f, 7.978f, 22.416f, 7.979f)
                curveTo(22.427f, 7.98f, 22.441f, 7.981f, 22.458f, 7.984f)
                curveTo(22.492f, 7.988f, 22.535f, 7.994f, 22.583f, 8.002f)
                lineTo(22.62f, 7.754f)
                curveTo(22.572f, 7.747f, 22.527f, 7.741f, 22.491f, 7.736f)
                curveTo(22.458f, 7.731f, 22.423f, 7.727f, 22.399f, 7.727f)
                verticalLineTo(7.977f)
                close()
                moveTo(22.313f, 7.662f)
                curveTo(22.298f, 7.691f, 22.275f, 7.736f, 22.263f, 7.775f)
                curveTo(22.259f, 7.79f, 22.247f, 7.832f, 22.261f, 7.877f)
                curveTo(22.269f, 7.905f, 22.287f, 7.934f, 22.319f, 7.954f)
                curveTo(22.348f, 7.973f, 22.378f, 7.977f, 22.399f, 7.977f)
                verticalLineTo(7.727f)
                curveTo(22.409f, 7.727f, 22.431f, 7.729f, 22.454f, 7.744f)
                curveTo(22.479f, 7.761f, 22.494f, 7.784f, 22.5f, 7.804f)
                curveTo(22.505f, 7.822f, 22.504f, 7.836f, 22.504f, 7.84f)
                curveTo(22.503f, 7.846f, 22.502f, 7.848f, 22.503f, 7.846f)
                curveTo(22.504f, 7.842f, 22.507f, 7.834f, 22.514f, 7.82f)
                curveTo(22.52f, 7.807f, 22.527f, 7.792f, 22.536f, 7.775f)
                lineTo(22.313f, 7.662f)
                close()
                moveTo(22.452f, 7.717f)
                curveTo(22.462f, 7.712f, 22.466f, 7.711f, 22.466f, 7.711f)
                curveTo(22.465f, 7.711f, 22.463f, 7.712f, 22.458f, 7.712f)
                curveTo(22.454f, 7.713f, 22.445f, 7.713f, 22.434f, 7.711f)
                curveTo(22.409f, 7.707f, 22.377f, 7.691f, 22.358f, 7.657f)
                curveTo(22.342f, 7.629f, 22.344f, 7.605f, 22.344f, 7.6f)
                curveTo(22.345f, 7.59f, 22.347f, 7.59f, 22.339f, 7.608f)
                curveTo(22.333f, 7.623f, 22.324f, 7.64f, 22.313f, 7.662f)
                lineTo(22.536f, 7.775f)
                curveTo(22.546f, 7.755f, 22.558f, 7.731f, 22.568f, 7.708f)
                curveTo(22.577f, 7.689f, 22.591f, 7.656f, 22.594f, 7.621f)
                curveTo(22.595f, 7.603f, 22.595f, 7.569f, 22.575f, 7.534f)
                curveTo(22.552f, 7.492f, 22.513f, 7.471f, 22.476f, 7.465f)
                curveTo(22.445f, 7.459f, 22.418f, 7.465f, 22.401f, 7.469f)
                curveTo(22.382f, 7.474f, 22.363f, 7.482f, 22.346f, 7.49f)
                lineTo(22.452f, 7.717f)
                close()
                moveTo(21.65f, 7.804f)
                curveTo(21.761f, 7.805f, 21.909f, 7.806f, 22.052f, 7.797f)
                curveTo(22.19f, 7.788f, 22.342f, 7.768f, 22.452f, 7.717f)
                lineTo(22.346f, 7.49f)
                curveTo(22.282f, 7.52f, 22.172f, 7.539f, 22.035f, 7.548f)
                curveTo(21.903f, 7.556f, 21.764f, 7.555f, 21.652f, 7.554f)
                lineTo(21.65f, 7.804f)
                close()
                moveTo(21.563f, 7.803f)
                curveTo(21.589f, 7.803f, 21.618f, 7.803f, 21.65f, 7.804f)
                lineTo(21.652f, 7.554f)
                curveTo(21.62f, 7.553f, 21.59f, 7.553f, 21.563f, 7.553f)
                verticalLineTo(7.803f)
                close()
                moveTo(21.479f, 7.445f)
                curveTo(21.467f, 7.457f, 21.449f, 7.476f, 21.433f, 7.497f)
                curveTo(21.418f, 7.515f, 21.397f, 7.544f, 21.384f, 7.578f)
                curveTo(21.372f, 7.608f, 21.352f, 7.684f, 21.411f, 7.747f)
                curveTo(21.459f, 7.798f, 21.526f, 7.803f, 21.563f, 7.803f)
                verticalLineTo(7.553f)
                curveTo(21.554f, 7.553f, 21.553f, 7.552f, 21.558f, 7.553f)
                curveTo(21.562f, 7.555f, 21.579f, 7.56f, 21.594f, 7.577f)
                curveTo(21.612f, 7.596f, 21.62f, 7.62f, 21.621f, 7.639f)
                curveTo(21.621f, 7.656f, 21.617f, 7.667f, 21.617f, 7.669f)
                curveTo(21.615f, 7.672f, 21.617f, 7.666f, 21.629f, 7.653f)
                curveTo(21.638f, 7.64f, 21.65f, 7.628f, 21.662f, 7.614f)
                lineTo(21.479f, 7.445f)
                close()
                moveTo(21.623f, 7.621f)
                curveTo(21.635f, 7.614f, 21.636f, 7.615f, 21.631f, 7.616f)
                curveTo(21.629f, 7.617f, 21.624f, 7.619f, 21.618f, 7.62f)
                curveTo(21.613f, 7.621f, 21.598f, 7.624f, 21.579f, 7.621f)
                curveTo(21.56f, 7.619f, 21.519f, 7.609f, 21.491f, 7.567f)
                curveTo(21.465f, 7.528f, 21.47f, 7.489f, 21.473f, 7.474f)
                curveTo(21.476f, 7.458f, 21.482f, 7.447f, 21.484f, 7.443f)
                curveTo(21.487f, 7.437f, 21.489f, 7.434f, 21.49f, 7.432f)
                curveTo(21.493f, 7.429f, 21.494f, 7.428f, 21.493f, 7.429f)
                curveTo(21.49f, 7.432f, 21.486f, 7.436f, 21.479f, 7.445f)
                lineTo(21.662f, 7.614f)
                curveTo(21.669f, 7.607f, 21.677f, 7.599f, 21.683f, 7.591f)
                curveTo(21.686f, 7.587f, 21.691f, 7.582f, 21.696f, 7.575f)
                curveTo(21.697f, 7.573f, 21.712f, 7.553f, 21.718f, 7.524f)
                curveTo(21.721f, 7.508f, 21.726f, 7.468f, 21.699f, 7.428f)
                curveTo(21.671f, 7.386f, 21.63f, 7.376f, 21.609f, 7.373f)
                curveTo(21.576f, 7.369f, 21.549f, 7.38f, 21.547f, 7.381f)
                curveTo(21.532f, 7.386f, 21.516f, 7.394f, 21.504f, 7.401f)
                lineTo(21.623f, 7.621f)
                close()
                moveTo(21.149f, 7.728f)
                curveTo(21.311f, 7.728f, 21.466f, 7.705f, 21.623f, 7.621f)
                lineTo(21.504f, 7.401f)
                curveTo(21.395f, 7.459f, 21.286f, 7.478f, 21.149f, 7.478f)
                verticalLineTo(7.728f)
                close()
                moveTo(20.933f, 7.595f)
                curveTo(20.941f, 7.61f, 20.962f, 7.648f, 20.999f, 7.679f)
                curveTo(21.041f, 7.713f, 21.093f, 7.728f, 21.149f, 7.728f)
                verticalLineTo(7.478f)
                curveTo(21.143f, 7.478f, 21.142f, 7.478f, 21.145f, 7.479f)
                curveTo(21.149f, 7.48f, 21.153f, 7.482f, 21.157f, 7.485f)
                curveTo(21.161f, 7.488f, 21.162f, 7.49f, 21.16f, 7.488f)
                curveTo(21.16f, 7.487f, 21.158f, 7.485f, 21.156f, 7.482f)
                curveTo(21.155f, 7.479f, 21.153f, 7.476f, 21.15f, 7.471f)
                lineTo(20.933f, 7.595f)
                close()
                moveTo(20.867f, 7.564f)
                curveTo(20.889f, 7.564f, 20.902f, 7.566f, 20.91f, 7.568f)
                curveTo(20.913f, 7.569f, 20.915f, 7.57f, 20.916f, 7.57f)
                curveTo(20.917f, 7.571f, 20.917f, 7.571f, 20.917f, 7.571f)
                curveTo(20.918f, 7.571f, 20.918f, 7.571f, 20.918f, 7.571f)
                curveTo(20.918f, 7.571f, 20.918f, 7.571f, 20.918f, 7.571f)
                curveTo(20.918f, 7.571f, 20.918f, 7.571f, 20.918f, 7.571f)
                curveTo(20.918f, 7.572f, 20.919f, 7.572f, 20.92f, 7.574f)
                curveTo(20.923f, 7.578f, 20.926f, 7.583f, 20.933f, 7.595f)
                lineTo(21.15f, 7.471f)
                curveTo(21.138f, 7.45f, 21.113f, 7.403f, 21.062f, 7.367f)
                curveTo(21.008f, 7.329f, 20.943f, 7.314f, 20.865f, 7.314f)
                lineTo(20.867f, 7.564f)
                close()
                moveTo(20.405f, 7.461f)
                curveTo(20.472f, 7.506f, 20.531f, 7.536f, 20.609f, 7.551f)
                curveTo(20.679f, 7.565f, 20.76f, 7.565f, 20.867f, 7.564f)
                lineTo(20.865f, 7.314f)
                curveTo(20.751f, 7.315f, 20.697f, 7.314f, 20.656f, 7.306f)
                curveTo(20.624f, 7.3f, 20.597f, 7.288f, 20.543f, 7.253f)
                lineTo(20.405f, 7.461f)
                close()
                moveTo(20.395f, 7.173f)
                curveTo(20.391f, 7.176f, 20.377f, 7.185f, 20.364f, 7.198f)
                curveTo(20.351f, 7.21f, 20.328f, 7.235f, 20.318f, 7.274f)
                curveTo(20.292f, 7.371f, 20.366f, 7.435f, 20.405f, 7.461f)
                lineTo(20.543f, 7.253f)
                curveTo(20.535f, 7.247f, 20.542f, 7.249f, 20.549f, 7.262f)
                curveTo(20.56f, 7.279f, 20.568f, 7.307f, 20.56f, 7.338f)
                curveTo(20.553f, 7.363f, 20.539f, 7.376f, 20.537f, 7.379f)
                curveTo(20.534f, 7.381f, 20.532f, 7.383f, 20.538f, 7.378f)
                lineTo(20.395f, 7.173f)
                close()
                moveTo(20.394f, 7.384f)
                curveTo(20.418f, 7.384f, 20.433f, 7.384f, 20.443f, 7.385f)
                curveTo(20.458f, 7.385f, 20.45f, 7.386f, 20.437f, 7.382f)
                curveTo(20.432f, 7.38f, 20.422f, 7.377f, 20.411f, 7.37f)
                curveTo(20.4f, 7.364f, 20.381f, 7.35f, 20.367f, 7.324f)
                curveTo(20.332f, 7.26f, 20.367f, 7.205f, 20.376f, 7.193f)
                curveTo(20.382f, 7.185f, 20.388f, 7.18f, 20.39f, 7.177f)
                curveTo(20.393f, 7.175f, 20.395f, 7.173f, 20.396f, 7.172f)
                curveTo(20.397f, 7.171f, 20.398f, 7.171f, 20.395f, 7.173f)
                lineTo(20.538f, 7.378f)
                curveTo(20.539f, 7.377f, 20.544f, 7.374f, 20.549f, 7.37f)
                curveTo(20.552f, 7.368f, 20.565f, 7.358f, 20.577f, 7.342f)
                curveTo(20.587f, 7.328f, 20.623f, 7.271f, 20.587f, 7.205f)
                curveTo(20.561f, 7.157f, 20.515f, 7.145f, 20.51f, 7.143f)
                curveTo(20.488f, 7.136f, 20.465f, 7.135f, 20.454f, 7.135f)
                curveTo(20.438f, 7.134f, 20.418f, 7.134f, 20.394f, 7.134f)
                verticalLineTo(7.384f)
                close()
                moveTo(19.794f, 7.384f)
                horizontalLineTo(20.394f)
                verticalLineTo(7.134f)
                horizontalLineTo(19.794f)
                verticalLineTo(7.384f)
                close()
                moveTo(19.903f, 6.938f)
                curveTo(19.847f, 6.938f, 19.788f, 6.96f, 19.745f, 6.981f)
                curveTo(19.698f, 7.003f, 19.648f, 7.034f, 19.61f, 7.071f)
                curveTo(19.591f, 7.088f, 19.568f, 7.114f, 19.554f, 7.148f)
                curveTo(19.538f, 7.185f, 19.53f, 7.243f, 19.566f, 7.297f)
                curveTo(19.597f, 7.344f, 19.645f, 7.363f, 19.677f, 7.371f)
                curveTo(19.712f, 7.38f, 19.752f, 7.384f, 19.794f, 7.384f)
                verticalLineTo(7.134f)
                curveTo(19.763f, 7.134f, 19.747f, 7.131f, 19.741f, 7.13f)
                curveTo(19.733f, 7.127f, 19.756f, 7.131f, 19.774f, 7.159f)
                curveTo(19.785f, 7.175f, 19.79f, 7.193f, 19.791f, 7.21f)
                curveTo(19.791f, 7.227f, 19.787f, 7.239f, 19.784f, 7.245f)
                curveTo(19.78f, 7.256f, 19.776f, 7.258f, 19.783f, 7.251f)
                curveTo(19.796f, 7.238f, 19.822f, 7.221f, 19.852f, 7.206f)
                curveTo(19.867f, 7.199f, 19.88f, 7.194f, 19.891f, 7.191f)
                curveTo(19.903f, 7.187f, 19.906f, 7.188f, 19.903f, 7.188f)
                verticalLineTo(6.938f)
                close()
                moveTo(19.943f, 7.084f)
                curveTo(19.968f, 7.075f, 19.984f, 7.072f, 19.992f, 7.07f)
                curveTo(20.003f, 7.069f, 19.997f, 7.072f, 19.982f, 7.068f)
                curveTo(19.964f, 7.062f, 19.929f, 7.044f, 19.915f, 7.001f)
                curveTo(19.903f, 6.965f, 19.914f, 6.938f, 19.917f, 6.932f)
                curveTo(19.922f, 6.921f, 19.924f, 6.924f, 19.912f, 6.932f)
                curveTo(19.902f, 6.939f, 19.898f, 6.938f, 19.903f, 6.938f)
                verticalLineTo(7.188f)
                curveTo(19.962f, 7.188f, 20.014f, 7.165f, 20.05f, 7.141f)
                curveTo(20.085f, 7.118f, 20.123f, 7.082f, 20.144f, 7.036f)
                curveTo(20.154f, 7.014f, 20.168f, 6.971f, 20.152f, 6.922f)
                curveTo(20.133f, 6.865f, 20.087f, 6.837f, 20.05f, 6.827f)
                curveTo(20.016f, 6.817f, 19.982f, 6.819f, 19.956f, 6.823f)
                curveTo(19.927f, 6.827f, 19.896f, 6.836f, 19.863f, 6.847f)
                lineTo(19.943f, 7.084f)
                close()
                moveTo(19.396f, 7.11f)
                curveTo(19.577f, 7.126f, 19.765f, 7.145f, 19.943f, 7.084f)
                lineTo(19.863f, 6.847f)
                curveTo(19.744f, 6.888f, 19.613f, 6.878f, 19.418f, 6.861f)
                lineTo(19.396f, 7.11f)
                close()
                moveTo(19.059f, 7.09f)
                curveTo(19.18f, 7.09f, 19.289f, 7.1f, 19.396f, 7.11f)
                lineTo(19.418f, 6.861f)
                curveTo(19.313f, 6.851f, 19.192f, 6.84f, 19.059f, 6.84f)
                verticalLineTo(7.09f)
                close()
                moveTo(18.846f, 6.702f)
                curveTo(18.788f, 6.702f, 18.718f, 6.71f, 18.667f, 6.748f)
                curveTo(18.637f, 6.77f, 18.603f, 6.811f, 18.603f, 6.871f)
                curveTo(18.603f, 6.925f, 18.632f, 6.964f, 18.653f, 6.985f)
                curveTo(18.695f, 7.027f, 18.757f, 7.051f, 18.817f, 7.065f)
                curveTo(18.882f, 7.081f, 18.962f, 7.09f, 19.059f, 7.09f)
                verticalLineTo(6.84f)
                curveTo(18.978f, 6.84f, 18.917f, 6.832f, 18.876f, 6.822f)
                curveTo(18.83f, 6.811f, 18.822f, 6.801f, 18.829f, 6.807f)
                curveTo(18.833f, 6.811f, 18.853f, 6.833f, 18.853f, 6.871f)
                curveTo(18.853f, 6.914f, 18.828f, 6.94f, 18.815f, 6.949f)
                curveTo(18.799f, 6.962f, 18.799f, 6.952f, 18.846f, 6.952f)
                verticalLineTo(6.702f)
                close()
                moveTo(18.742f, 6.851f)
                curveTo(18.818f, 6.851f, 18.868f, 6.857f, 18.897f, 6.864f)
                curveTo(18.912f, 6.867f, 18.917f, 6.87f, 18.916f, 6.869f)
                curveTo(18.915f, 6.869f, 18.911f, 6.867f, 18.905f, 6.861f)
                curveTo(18.899f, 6.856f, 18.889f, 6.846f, 18.881f, 6.828f)
                curveTo(18.872f, 6.809f, 18.868f, 6.786f, 18.873f, 6.761f)
                curveTo(18.878f, 6.738f, 18.889f, 6.722f, 18.897f, 6.713f)
                curveTo(18.912f, 6.696f, 18.925f, 6.693f, 18.92f, 6.694f)
                curveTo(18.914f, 6.697f, 18.891f, 6.702f, 18.846f, 6.702f)
                verticalLineTo(6.952f)
                curveTo(18.906f, 6.952f, 18.962f, 6.945f, 19.007f, 6.929f)
                curveTo(19.028f, 6.921f, 19.06f, 6.906f, 19.085f, 6.878f)
                curveTo(19.098f, 6.863f, 19.112f, 6.84f, 19.118f, 6.811f)
                curveTo(19.125f, 6.78f, 19.12f, 6.75f, 19.109f, 6.725f)
                curveTo(19.088f, 6.68f, 19.051f, 6.657f, 19.031f, 6.647f)
                curveTo(19.007f, 6.635f, 18.98f, 6.626f, 18.953f, 6.62f)
                curveTo(18.899f, 6.608f, 18.829f, 6.601f, 18.742f, 6.601f)
                verticalLineTo(6.851f)
                close()
                moveTo(18.211f, 6.765f)
                curveTo(18.337f, 6.8f, 18.519f, 6.851f, 18.742f, 6.851f)
                verticalLineTo(6.601f)
                curveTo(18.557f, 6.601f, 18.403f, 6.559f, 18.278f, 6.524f)
                lineTo(18.211f, 6.765f)
                close()
                moveTo(18.069f, 6.732f)
                curveTo(18.09f, 6.732f, 18.129f, 6.742f, 18.211f, 6.765f)
                lineTo(18.278f, 6.524f)
                curveTo(18.212f, 6.506f, 18.133f, 6.482f, 18.069f, 6.482f)
                verticalLineTo(6.732f)
                close()
                moveTo(18.069f, 6.346f)
                curveTo(18.003f, 6.346f, 17.936f, 6.354f, 17.885f, 6.387f)
                curveTo(17.856f, 6.405f, 17.826f, 6.435f, 17.813f, 6.479f)
                curveTo(17.8f, 6.522f, 17.809f, 6.562f, 17.822f, 6.591f)
                curveTo(17.846f, 6.643f, 17.892f, 6.677f, 17.928f, 6.696f)
                curveTo(17.967f, 6.717f, 18.017f, 6.732f, 18.069f, 6.732f)
                verticalLineTo(6.482f)
                curveTo(18.063f, 6.482f, 18.054f, 6.48f, 18.045f, 6.476f)
                curveTo(18.041f, 6.473f, 18.039f, 6.472f, 18.04f, 6.472f)
                curveTo(18.04f, 6.472f, 18.041f, 6.473f, 18.043f, 6.476f)
                curveTo(18.044f, 6.478f, 18.047f, 6.482f, 18.049f, 6.487f)
                curveTo(18.055f, 6.499f, 18.061f, 6.522f, 18.053f, 6.55f)
                curveTo(18.045f, 6.578f, 18.027f, 6.593f, 18.018f, 6.598f)
                curveTo(18.011f, 6.603f, 18.009f, 6.602f, 18.019f, 6.6f)
                curveTo(18.028f, 6.598f, 18.044f, 6.596f, 18.069f, 6.596f)
                verticalLineTo(6.346f)
                close()
                moveTo(18.353f, 6.483f)
                curveTo(18.382f, 6.483f, 18.397f, 6.484f, 18.402f, 6.485f)
                curveTo(18.404f, 6.486f, 18.399f, 6.485f, 18.389f, 6.48f)
                curveTo(18.382f, 6.477f, 18.352f, 6.461f, 18.336f, 6.422f)
                curveTo(18.317f, 6.375f, 18.334f, 6.335f, 18.346f, 6.316f)
                curveTo(18.356f, 6.3f, 18.368f, 6.292f, 18.368f, 6.292f)
                curveTo(18.372f, 6.289f, 18.369f, 6.292f, 18.354f, 6.298f)
                curveTo(18.294f, 6.32f, 18.173f, 6.346f, 18.069f, 6.346f)
                verticalLineTo(6.596f)
                curveTo(18.203f, 6.596f, 18.355f, 6.565f, 18.443f, 6.531f)
                curveTo(18.465f, 6.523f, 18.491f, 6.511f, 18.513f, 6.496f)
                curveTo(18.523f, 6.488f, 18.541f, 6.474f, 18.556f, 6.452f)
                curveTo(18.572f, 6.427f, 18.589f, 6.381f, 18.568f, 6.328f)
                curveTo(18.55f, 6.284f, 18.515f, 6.264f, 18.499f, 6.256f)
                curveTo(18.48f, 6.247f, 18.462f, 6.242f, 18.449f, 6.24f)
                curveTo(18.421f, 6.234f, 18.388f, 6.233f, 18.353f, 6.233f)
                verticalLineTo(6.483f)
                close()
                moveTo(17.711f, 6.354f)
                curveTo(17.818f, 6.383f, 17.936f, 6.415f, 18.046f, 6.439f)
                curveTo(18.154f, 6.463f, 18.264f, 6.483f, 18.353f, 6.483f)
                verticalLineTo(6.233f)
                curveTo(18.293f, 6.233f, 18.206f, 6.219f, 18.1f, 6.195f)
                curveTo(17.997f, 6.172f, 17.884f, 6.142f, 17.776f, 6.113f)
                lineTo(17.711f, 6.354f)
                close()
                moveTo(17.365f, 6.275f)
                curveTo(17.382f, 6.275f, 17.422f, 6.281f, 17.489f, 6.297f)
                curveTo(17.553f, 6.312f, 17.628f, 6.332f, 17.711f, 6.354f)
                lineTo(17.776f, 6.113f)
                curveTo(17.694f, 6.091f, 17.615f, 6.069f, 17.546f, 6.053f)
                curveTo(17.482f, 6.038f, 17.415f, 6.025f, 17.365f, 6.025f)
                verticalLineTo(6.275f)
                close()
                moveTo(17.48f, 5.993f)
                curveTo(17.427f, 6.002f, 17.377f, 6.011f, 17.347f, 6.018f)
                curveTo(17.339f, 6.02f, 17.33f, 6.022f, 17.322f, 6.024f)
                curveTo(17.318f, 6.025f, 17.313f, 6.027f, 17.306f, 6.029f)
                curveTo(17.304f, 6.03f, 17.286f, 6.037f, 17.269f, 6.052f)
                curveTo(17.262f, 6.058f, 17.235f, 6.081f, 17.227f, 6.122f)
                curveTo(17.215f, 6.177f, 17.242f, 6.22f, 17.266f, 6.241f)
                curveTo(17.285f, 6.258f, 17.304f, 6.265f, 17.31f, 6.267f)
                curveTo(17.319f, 6.27f, 17.326f, 6.272f, 17.33f, 6.272f)
                curveTo(17.345f, 6.275f, 17.359f, 6.275f, 17.365f, 6.275f)
                verticalLineTo(6.025f)
                curveTo(17.359f, 6.025f, 17.364f, 6.024f, 17.373f, 6.026f)
                curveTo(17.376f, 6.026f, 17.382f, 6.028f, 17.39f, 6.03f)
                curveTo(17.396f, 6.032f, 17.414f, 6.039f, 17.433f, 6.055f)
                curveTo(17.456f, 6.076f, 17.483f, 6.119f, 17.472f, 6.173f)
                curveTo(17.463f, 6.214f, 17.437f, 6.237f, 17.43f, 6.243f)
                curveTo(17.42f, 6.251f, 17.411f, 6.256f, 17.408f, 6.258f)
                curveTo(17.403f, 6.26f, 17.4f, 6.261f, 17.398f, 6.262f)
                curveTo(17.396f, 6.263f, 17.395f, 6.263f, 17.394f, 6.264f)
                curveTo(17.393f, 6.264f, 17.392f, 6.264f, 17.392f, 6.264f)
                curveTo(17.392f, 6.264f, 17.393f, 6.264f, 17.395f, 6.263f)
                curveTo(17.396f, 6.263f, 17.398f, 6.263f, 17.401f, 6.262f)
                curveTo(17.425f, 6.257f, 17.469f, 6.249f, 17.524f, 6.239f)
                lineTo(17.48f, 5.993f)
                close()
                moveTo(17.629f, 6.143f)
                curveTo(17.679f, 6.143f, 17.716f, 6.144f, 17.743f, 6.146f)
                curveTo(17.772f, 6.147f, 17.782f, 6.149f, 17.782f, 6.149f)
                curveTo(17.781f, 6.149f, 17.778f, 6.148f, 17.773f, 6.146f)
                curveTo(17.768f, 6.144f, 17.757f, 6.139f, 17.745f, 6.129f)
                curveTo(17.733f, 6.119f, 17.711f, 6.097f, 17.704f, 6.06f)
                curveTo(17.697f, 6.022f, 17.709f, 5.99f, 17.72f, 5.972f)
                curveTo(17.731f, 5.955f, 17.743f, 5.946f, 17.748f, 5.942f)
                curveTo(17.754f, 5.938f, 17.758f, 5.935f, 17.76f, 5.934f)
                curveTo(17.763f, 5.933f, 17.764f, 5.933f, 17.759f, 5.934f)
                curveTo(17.74f, 5.941f, 17.701f, 5.95f, 17.646f, 5.961f)
                curveTo(17.593f, 5.972f, 17.534f, 5.983f, 17.48f, 5.993f)
                lineTo(17.524f, 6.239f)
                curveTo(17.626f, 6.22f, 17.773f, 6.194f, 17.841f, 6.17f)
                curveTo(17.851f, 6.167f, 17.863f, 6.162f, 17.875f, 6.156f)
                curveTo(17.881f, 6.153f, 17.911f, 6.138f, 17.932f, 6.106f)
                curveTo(17.945f, 6.085f, 17.957f, 6.052f, 17.949f, 6.011f)
                curveTo(17.942f, 5.973f, 17.919f, 5.949f, 17.905f, 5.937f)
                curveTo(17.879f, 5.916f, 17.852f, 5.909f, 17.843f, 5.907f)
                curveTo(17.801f, 5.896f, 17.727f, 5.893f, 17.629f, 5.893f)
                verticalLineTo(6.143f)
                close()
                moveTo(16.344f, 5.613f)
                curveTo(16.502f, 5.716f, 16.703f, 5.848f, 16.921f, 5.954f)
                curveTo(17.138f, 6.059f, 17.382f, 6.143f, 17.629f, 6.143f)
                verticalLineTo(5.893f)
                curveTo(17.436f, 5.893f, 17.232f, 5.827f, 17.03f, 5.729f)
                curveTo(16.829f, 5.631f, 16.641f, 5.508f, 16.481f, 5.404f)
                lineTo(16.344f, 5.613f)
                close()
                moveTo(16.062f, 5.443f)
                curveTo(16.117f, 5.465f, 16.209f, 5.524f, 16.344f, 5.613f)
                lineTo(16.481f, 5.404f)
                curveTo(16.358f, 5.323f, 16.239f, 5.244f, 16.152f, 5.21f)
                lineTo(16.062f, 5.443f)
                close()
                moveTo(16.27f, 5.038f)
                curveTo(16.207f, 4.968f, 16.119f, 4.974f, 16.069f, 4.988f)
                curveTo(16.015f, 5.003f, 15.963f, 5.036f, 15.926f, 5.081f)
                curveTo(15.889f, 5.127f, 15.857f, 5.201f, 15.886f, 5.285f)
                curveTo(15.914f, 5.365f, 15.985f, 5.414f, 16.062f, 5.443f)
                lineTo(16.152f, 5.21f)
                curveTo(16.105f, 5.192f, 16.115f, 5.182f, 16.122f, 5.202f)
                curveTo(16.126f, 5.213f, 16.125f, 5.223f, 16.124f, 5.231f)
                curveTo(16.122f, 5.237f, 16.12f, 5.24f, 16.121f, 5.238f)
                curveTo(16.122f, 5.237f, 16.124f, 5.235f, 16.128f, 5.232f)
                curveTo(16.132f, 5.23f, 16.135f, 5.229f, 16.136f, 5.229f)
                curveTo(16.137f, 5.228f, 16.133f, 5.23f, 16.124f, 5.228f)
                curveTo(16.114f, 5.227f, 16.099f, 5.221f, 16.086f, 5.207f)
                lineTo(16.27f, 5.038f)
                close()
                moveTo(16.476f, 5.328f)
                curveTo(16.505f, 5.342f, 16.503f, 5.344f, 16.494f, 5.335f)
                curveTo(16.491f, 5.332f, 16.48f, 5.322f, 16.472f, 5.305f)
                curveTo(16.463f, 5.287f, 16.451f, 5.249f, 16.468f, 5.206f)
                curveTo(16.484f, 5.165f, 16.516f, 5.147f, 16.53f, 5.141f)
                curveTo(16.544f, 5.134f, 16.556f, 5.132f, 16.56f, 5.132f)
                curveTo(16.572f, 5.13f, 16.573f, 5.132f, 16.553f, 5.129f)
                curveTo(16.537f, 5.126f, 16.516f, 5.122f, 16.492f, 5.116f)
                curveTo(16.443f, 5.104f, 16.386f, 5.086f, 16.338f, 5.068f)
                curveTo(16.314f, 5.058f, 16.295f, 5.05f, 16.281f, 5.042f)
                curveTo(16.263f, 5.033f, 16.264f, 5.031f, 16.27f, 5.038f)
                lineTo(16.086f, 5.207f)
                curveTo(16.11f, 5.233f, 16.141f, 5.252f, 16.164f, 5.263f)
                curveTo(16.19f, 5.277f, 16.219f, 5.29f, 16.248f, 5.301f)
                curveTo(16.307f, 5.324f, 16.374f, 5.344f, 16.431f, 5.358f)
                curveTo(16.46f, 5.366f, 16.488f, 5.372f, 16.512f, 5.376f)
                curveTo(16.531f, 5.379f, 16.563f, 5.384f, 16.592f, 5.38f)
                curveTo(16.6f, 5.379f, 16.616f, 5.376f, 16.633f, 5.368f)
                curveTo(16.65f, 5.361f, 16.683f, 5.341f, 16.7f, 5.298f)
                curveTo(16.718f, 5.253f, 16.706f, 5.213f, 16.695f, 5.193f)
                curveTo(16.685f, 5.173f, 16.673f, 5.16f, 16.666f, 5.154f)
                curveTo(16.643f, 5.132f, 16.61f, 5.115f, 16.585f, 5.103f)
                lineTo(16.476f, 5.328f)
                close()
                moveTo(16.007f, 4.912f)
                curveTo(16.079f, 5.01f, 16.232f, 5.209f, 16.476f, 5.328f)
                lineTo(16.585f, 5.103f)
                curveTo(16.399f, 5.013f, 16.277f, 4.857f, 16.208f, 4.763f)
                lineTo(16.007f, 4.912f)
                close()
                moveTo(16.26f, 4.656f)
                curveTo(16.228f, 4.629f, 16.188f, 4.604f, 16.142f, 4.596f)
                curveTo(16.093f, 4.587f, 16.03f, 4.598f, 15.986f, 4.651f)
                curveTo(15.947f, 4.699f, 15.946f, 4.756f, 15.953f, 4.796f)
                curveTo(15.961f, 4.838f, 15.981f, 4.877f, 16.007f, 4.912f)
                lineTo(16.208f, 4.763f)
                curveTo(16.198f, 4.75f, 16.198f, 4.745f, 16.199f, 4.75f)
                curveTo(16.199f, 4.753f, 16.204f, 4.78f, 16.18f, 4.809f)
                curveTo(16.152f, 4.843f, 16.115f, 4.845f, 16.098f, 4.842f)
                curveTo(16.085f, 4.84f, 16.084f, 4.835f, 16.096f, 4.845f)
                lineTo(16.26f, 4.656f)
                close()
                moveTo(16.668f, 5.044f)
                curveTo(16.728f, 4.935f, 16.728f, 4.935f, 16.728f, 4.935f)
                curveTo(16.728f, 4.935f, 16.728f, 4.935f, 16.728f, 4.935f)
                curveTo(16.728f, 4.935f, 16.728f, 4.935f, 16.727f, 4.935f)
                curveTo(16.727f, 4.935f, 16.727f, 4.934f, 16.727f, 4.934f)
                curveTo(16.727f, 4.934f, 16.727f, 4.934f, 16.726f, 4.934f)
                curveTo(16.726f, 4.934f, 16.725f, 4.933f, 16.723f, 4.932f)
                curveTo(16.72f, 4.931f, 16.716f, 4.928f, 16.71f, 4.925f)
                curveTo(16.699f, 4.919f, 16.684f, 4.911f, 16.664f, 4.9f)
                curveTo(16.625f, 4.878f, 16.573f, 4.849f, 16.518f, 4.818f)
                curveTo(16.463f, 4.786f, 16.406f, 4.752f, 16.357f, 4.722f)
                curveTo(16.306f, 4.691f, 16.273f, 4.668f, 16.26f, 4.656f)
                lineTo(16.096f, 4.845f)
                curveTo(16.126f, 4.872f, 16.176f, 4.904f, 16.225f, 4.935f)
                curveTo(16.277f, 4.967f, 16.337f, 5.002f, 16.394f, 5.035f)
                curveTo(16.45f, 5.067f, 16.504f, 5.097f, 16.543f, 5.119f)
                curveTo(16.563f, 5.13f, 16.579f, 5.138f, 16.591f, 5.145f)
                curveTo(16.596f, 5.148f, 16.601f, 5.15f, 16.604f, 5.152f)
                curveTo(16.605f, 5.153f, 16.606f, 5.153f, 16.607f, 5.154f)
                curveTo(16.608f, 5.154f, 16.608f, 5.154f, 16.608f, 5.154f)
                curveTo(16.608f, 5.154f, 16.608f, 5.154f, 16.608f, 5.154f)
                curveTo(16.608f, 5.154f, 16.608f, 5.154f, 16.608f, 5.154f)
                curveTo(16.608f, 5.154f, 16.608f, 5.154f, 16.608f, 5.154f)
                curveTo(16.608f, 5.154f, 16.608f, 5.154f, 16.668f, 5.044f)
                close()
                moveTo(16.171f, 4.572f)
                curveTo(16.261f, 4.743f, 16.363f, 4.883f, 16.442f, 4.98f)
                curveTo(16.482f, 5.028f, 16.516f, 5.066f, 16.54f, 5.093f)
                curveTo(16.553f, 5.106f, 16.563f, 5.116f, 16.57f, 5.123f)
                curveTo(16.573f, 5.126f, 16.576f, 5.129f, 16.578f, 5.131f)
                curveTo(16.579f, 5.132f, 16.58f, 5.133f, 16.58f, 5.134f)
                curveTo(16.581f, 5.134f, 16.581f, 5.134f, 16.581f, 5.134f)
                curveTo(16.581f, 5.134f, 16.581f, 5.134f, 16.581f, 5.135f)
                curveTo(16.581f, 5.135f, 16.581f, 5.135f, 16.581f, 5.135f)
                curveTo(16.581f, 5.135f, 16.581f, 5.135f, 16.581f, 5.135f)
                curveTo(16.581f, 5.135f, 16.581f, 5.135f, 16.668f, 5.044f)
                curveTo(16.754f, 4.954f, 16.755f, 4.954f, 16.755f, 4.954f)
                curveTo(16.755f, 4.954f, 16.755f, 4.954f, 16.755f, 4.954f)
                curveTo(16.755f, 4.954f, 16.755f, 4.954f, 16.755f, 4.954f)
                curveTo(16.755f, 4.954f, 16.755f, 4.954f, 16.755f, 4.954f)
                curveTo(16.755f, 4.954f, 16.755f, 4.954f, 16.754f, 4.954f)
                curveTo(16.754f, 4.954f, 16.754f, 4.954f, 16.753f, 4.953f)
                curveTo(16.752f, 4.952f, 16.75f, 4.95f, 16.747f, 4.947f)
                curveTo(16.742f, 4.942f, 16.733f, 4.933f, 16.723f, 4.922f)
                curveTo(16.702f, 4.899f, 16.671f, 4.865f, 16.636f, 4.822f)
                curveTo(16.564f, 4.734f, 16.473f, 4.608f, 16.392f, 4.455f)
                lineTo(16.171f, 4.572f)
                close()
                moveTo(16.826f, 4.418f)
                curveTo(16.746f, 4.351f, 16.662f, 4.295f, 16.583f, 4.254f)
                curveTo(16.506f, 4.214f, 16.425f, 4.183f, 16.352f, 4.176f)
                curveTo(16.315f, 4.172f, 16.271f, 4.174f, 16.229f, 4.191f)
                curveTo(16.182f, 4.21f, 16.143f, 4.247f, 16.123f, 4.299f)
                curveTo(16.106f, 4.347f, 16.109f, 4.397f, 16.118f, 4.438f)
                curveTo(16.128f, 4.481f, 16.146f, 4.526f, 16.171f, 4.572f)
                lineTo(16.392f, 4.455f)
                curveTo(16.374f, 4.421f, 16.365f, 4.397f, 16.362f, 4.383f)
                curveTo(16.359f, 4.368f, 16.363f, 4.372f, 16.358f, 4.386f)
                curveTo(16.351f, 4.404f, 16.336f, 4.417f, 16.323f, 4.422f)
                curveTo(16.314f, 4.426f, 16.313f, 4.423f, 16.327f, 4.425f)
                curveTo(16.355f, 4.427f, 16.404f, 4.442f, 16.468f, 4.476f)
                curveTo(16.53f, 4.508f, 16.598f, 4.554f, 16.666f, 4.61f)
                lineTo(16.826f, 4.418f)
                close()
                moveTo(17.465f, 4.713f)
                curveTo(17.347f, 4.701f, 17.097f, 4.645f, 16.826f, 4.418f)
                lineTo(16.666f, 4.61f)
                curveTo(16.981f, 4.873f, 17.28f, 4.946f, 17.439f, 4.962f)
                lineTo(17.465f, 4.713f)
                close()
                moveTo(16.987f, 4.623f)
                curveTo(17.118f, 4.695f, 17.247f, 4.777f, 17.326f, 4.836f)
                curveTo(17.345f, 4.851f, 17.36f, 4.863f, 17.37f, 4.872f)
                curveTo(17.382f, 4.883f, 17.381f, 4.884f, 17.376f, 4.877f)
                curveTo(17.374f, 4.873f, 17.365f, 4.857f, 17.364f, 4.831f)
                curveTo(17.362f, 4.798f, 17.376f, 4.761f, 17.406f, 4.737f)
                curveTo(17.43f, 4.717f, 17.453f, 4.714f, 17.458f, 4.714f)
                curveTo(17.465f, 4.713f, 17.468f, 4.714f, 17.465f, 4.713f)
                lineTo(17.439f, 4.962f)
                curveTo(17.453f, 4.963f, 17.47f, 4.964f, 17.488f, 4.962f)
                curveTo(17.504f, 4.96f, 17.535f, 4.954f, 17.563f, 4.931f)
                curveTo(17.599f, 4.902f, 17.615f, 4.86f, 17.613f, 4.82f)
                curveTo(17.612f, 4.788f, 17.6f, 4.763f, 17.592f, 4.751f)
                curveTo(17.577f, 4.725f, 17.556f, 4.704f, 17.54f, 4.689f)
                curveTo(17.521f, 4.672f, 17.5f, 4.654f, 17.477f, 4.637f)
                curveTo(17.385f, 4.567f, 17.244f, 4.48f, 17.109f, 4.404f)
                lineTo(16.987f, 4.623f)
                close()
                moveTo(17.138f, 3.962f)
                curveTo(17.103f, 3.927f, 17.061f, 3.895f, 17.01f, 3.882f)
                curveTo(16.953f, 3.867f, 16.896f, 3.877f, 16.851f, 3.911f)
                curveTo(16.809f, 3.941f, 16.785f, 3.983f, 16.771f, 4.02f)
                curveTo(16.757f, 4.058f, 16.749f, 4.099f, 16.747f, 4.139f)
                curveTo(16.737f, 4.291f, 16.797f, 4.517f, 16.987f, 4.623f)
                lineTo(17.109f, 4.404f)
                curveTo(17.034f, 4.363f, 16.99f, 4.252f, 16.996f, 4.155f)
                curveTo(16.997f, 4.133f, 17.001f, 4.118f, 17.005f, 4.109f)
                curveTo(17.008f, 4.099f, 17.009f, 4.105f, 16.998f, 4.113f)
                curveTo(16.982f, 4.124f, 16.962f, 4.127f, 16.947f, 4.123f)
                curveTo(16.937f, 4.121f, 16.941f, 4.119f, 16.959f, 4.136f)
                lineTo(17.138f, 3.962f)
                close()
                moveTo(18.204f, 4.457f)
                curveTo(17.956f, 4.354f, 17.708f, 4.252f, 17.508f, 4.161f)
                curveTo(17.408f, 4.116f, 17.323f, 4.075f, 17.256f, 4.039f)
                curveTo(17.186f, 4f, 17.15f, 3.974f, 17.138f, 3.962f)
                lineTo(16.959f, 4.136f)
                curveTo(17f, 4.179f, 17.067f, 4.22f, 17.137f, 4.258f)
                curveTo(17.211f, 4.298f, 17.303f, 4.343f, 17.405f, 4.389f)
                curveTo(17.609f, 4.481f, 17.862f, 4.586f, 18.108f, 4.688f)
                lineTo(18.204f, 4.457f)
                close()
                moveTo(19.257f, 4.95f)
                curveTo(19.216f, 4.915f, 19.156f, 4.879f, 19.09f, 4.845f)
                curveTo(19.021f, 4.809f, 18.938f, 4.769f, 18.845f, 4.728f)
                curveTo(18.659f, 4.645f, 18.432f, 4.551f, 18.204f, 4.457f)
                lineTo(18.108f, 4.688f)
                curveTo(18.337f, 4.782f, 18.561f, 4.875f, 18.743f, 4.956f)
                curveTo(18.833f, 4.996f, 18.912f, 5.034f, 18.974f, 5.066f)
                curveTo(19.038f, 5.1f, 19.077f, 5.125f, 19.094f, 5.139f)
                lineTo(19.257f, 4.95f)
                close()
                moveTo(18.934f, 4.75f)
                curveTo(19.024f, 4.892f, 19.103f, 5.017f, 19.136f, 5.086f)
                curveTo(19.144f, 5.104f, 19.146f, 5.11f, 19.145f, 5.108f)
                curveTo(19.145f, 5.106f, 19.144f, 5.103f, 19.144f, 5.098f)
                curveTo(19.143f, 5.094f, 19.143f, 5.085f, 19.145f, 5.074f)
                curveTo(19.148f, 5.05f, 19.165f, 5.004f, 19.217f, 4.984f)
                curveTo(19.256f, 4.968f, 19.288f, 4.979f, 19.292f, 4.98f)
                curveTo(19.3f, 4.983f, 19.303f, 4.985f, 19.3f, 4.983f)
                curveTo(19.294f, 4.979f, 19.28f, 4.97f, 19.257f, 4.95f)
                lineTo(19.094f, 5.139f)
                curveTo(19.121f, 5.162f, 19.146f, 5.182f, 19.169f, 5.196f)
                curveTo(19.18f, 5.203f, 19.195f, 5.211f, 19.213f, 5.217f)
                curveTo(19.227f, 5.222f, 19.266f, 5.233f, 19.31f, 5.215f)
                curveTo(19.367f, 5.192f, 19.387f, 5.142f, 19.392f, 5.111f)
                curveTo(19.396f, 5.084f, 19.391f, 5.061f, 19.388f, 5.05f)
                curveTo(19.382f, 5.025f, 19.371f, 4.999f, 19.361f, 4.978f)
                curveTo(19.32f, 4.893f, 19.231f, 4.751f, 19.146f, 4.616f)
                lineTo(18.934f, 4.75f)
                close()
                moveTo(18.828f, 4.579f)
                curveTo(18.862f, 4.635f, 18.899f, 4.693f, 18.934f, 4.75f)
                lineTo(19.146f, 4.616f)
                curveTo(19.11f, 4.56f, 19.074f, 4.503f, 19.041f, 4.448f)
                lineTo(18.828f, 4.579f)
                close()
                moveTo(19.867f, 4.669f)
                curveTo(19.604f, 4.549f, 19.349f, 4.431f, 19.174f, 4.369f)
                curveTo(19.13f, 4.353f, 19.089f, 4.34f, 19.052f, 4.33f)
                curveTo(19.018f, 4.322f, 18.977f, 4.315f, 18.939f, 4.317f)
                curveTo(18.92f, 4.319f, 18.891f, 4.323f, 18.863f, 4.341f)
                curveTo(18.83f, 4.36f, 18.805f, 4.392f, 18.795f, 4.433f)
                curveTo(18.787f, 4.469f, 18.794f, 4.501f, 18.8f, 4.522f)
                curveTo(18.807f, 4.543f, 18.818f, 4.562f, 18.828f, 4.579f)
                lineTo(19.041f, 4.448f)
                curveTo(19.037f, 4.441f, 19.037f, 4.44f, 19.038f, 4.444f)
                curveTo(19.039f, 4.448f, 19.045f, 4.465f, 19.039f, 4.489f)
                curveTo(19.032f, 4.518f, 19.014f, 4.542f, 18.992f, 4.555f)
                curveTo(18.974f, 4.566f, 18.959f, 4.567f, 18.958f, 4.567f)
                curveTo(18.955f, 4.567f, 18.964f, 4.566f, 18.992f, 4.573f)
                curveTo(19.017f, 4.579f, 19.05f, 4.59f, 19.09f, 4.604f)
                curveTo(19.252f, 4.662f, 19.495f, 4.774f, 19.762f, 4.896f)
                lineTo(19.867f, 4.669f)
                close()
                moveTo(20.898f, 5.095f)
                curveTo(20.656f, 5.031f, 20.254f, 4.847f, 19.867f, 4.669f)
                lineTo(19.762f, 4.896f)
                curveTo(20.139f, 5.069f, 20.566f, 5.266f, 20.834f, 5.336f)
                lineTo(20.898f, 5.095f)
                close()
                moveTo(21.502f, 5.29f)
                curveTo(21.294f, 5.217f, 21.079f, 5.142f, 20.898f, 5.095f)
                lineTo(20.834f, 5.336f)
                curveTo(21.004f, 5.381f, 21.209f, 5.452f, 21.42f, 5.526f)
                lineTo(21.502f, 5.29f)
                close()
                moveTo(22.369f, 5.535f)
                curveTo(22.369f, 5.541f, 22.368f, 5.532f, 22.377f, 5.522f)
                curveTo(22.384f, 5.514f, 22.389f, 5.516f, 22.377f, 5.518f)
                curveTo(22.348f, 5.525f, 22.29f, 5.524f, 22.196f, 5.505f)
                curveTo(22.013f, 5.469f, 21.764f, 5.382f, 21.502f, 5.29f)
                lineTo(21.42f, 5.526f)
                curveTo(21.675f, 5.616f, 21.943f, 5.71f, 22.147f, 5.751f)
                curveTo(22.247f, 5.77f, 22.35f, 5.782f, 22.434f, 5.762f)
                curveTo(22.478f, 5.751f, 22.527f, 5.73f, 22.565f, 5.687f)
                curveTo(22.604f, 5.643f, 22.619f, 5.589f, 22.619f, 5.535f)
                horizontalLineTo(22.369f)
                close()
                moveTo(23.434f, 4.395f)
                curveTo(23.157f, 4.491f, 22.896f, 4.676f, 22.703f, 4.88f)
                curveTo(22.606f, 4.983f, 22.524f, 5.093f, 22.466f, 5.202f)
                curveTo(22.408f, 5.31f, 22.369f, 5.425f, 22.369f, 5.535f)
                horizontalLineTo(22.619f)
                curveTo(22.619f, 5.481f, 22.639f, 5.407f, 22.686f, 5.32f)
                curveTo(22.732f, 5.234f, 22.8f, 5.142f, 22.885f, 5.052f)
                curveTo(23.055f, 4.872f, 23.284f, 4.712f, 23.515f, 4.632f)
                lineTo(23.434f, 4.395f)
                close()
                moveTo(24.207f, 4.525f)
                curveTo(24.115f, 4.464f, 24.013f, 4.395f, 23.887f, 4.362f)
                curveTo(23.757f, 4.327f, 23.612f, 4.334f, 23.434f, 4.395f)
                lineTo(23.515f, 4.632f)
                curveTo(23.658f, 4.583f, 23.75f, 4.584f, 23.823f, 4.603f)
                curveTo(23.902f, 4.624f, 23.971f, 4.668f, 24.069f, 4.733f)
                lineTo(24.207f, 4.525f)
                close()
                moveTo(24.584f, 4.718f)
                curveTo(24.427f, 4.67f, 24.317f, 4.597f, 24.207f, 4.525f)
                lineTo(24.069f, 4.733f)
                curveTo(24.18f, 4.806f, 24.315f, 4.897f, 24.51f, 4.957f)
                lineTo(24.584f, 4.718f)
                close()
                moveTo(24.084f, 7.71f)
                curveTo(23.959f, 7.714f, 23.959f, 7.714f, 23.959f, 7.714f)
                curveTo(23.959f, 7.714f, 23.959f, 7.714f, 23.959f, 7.714f)
                curveTo(23.959f, 7.714f, 23.959f, 7.714f, 23.959f, 7.714f)
                curveTo(23.959f, 7.714f, 23.959f, 7.714f, 23.959f, 7.715f)
                curveTo(23.959f, 7.715f, 23.959f, 7.716f, 23.959f, 7.717f)
                curveTo(23.96f, 7.719f, 23.96f, 7.721f, 23.96f, 7.725f)
                curveTo(23.96f, 7.732f, 23.96f, 7.743f, 23.961f, 7.756f)
                curveTo(23.961f, 7.783f, 23.962f, 7.822f, 23.962f, 7.869f)
                curveTo(23.964f, 7.962f, 23.964f, 8.085f, 23.961f, 8.209f)
                curveTo(23.958f, 8.333f, 23.951f, 8.453f, 23.939f, 8.54f)
                curveTo(23.933f, 8.584f, 23.926f, 8.613f, 23.92f, 8.627f)
                curveTo(23.917f, 8.635f, 23.918f, 8.631f, 23.925f, 8.623f)
                curveTo(23.932f, 8.614f, 23.957f, 8.589f, 24.001f, 8.589f)
                verticalLineTo(8.839f)
                curveTo(24.059f, 8.839f, 24.098f, 8.805f, 24.118f, 8.782f)
                curveTo(24.136f, 8.759f, 24.148f, 8.733f, 24.155f, 8.714f)
                curveTo(24.17f, 8.674f, 24.179f, 8.624f, 24.186f, 8.574f)
                curveTo(24.201f, 8.473f, 24.207f, 8.342f, 24.211f, 8.215f)
                curveTo(24.214f, 8.088f, 24.214f, 7.96f, 24.212f, 7.865f)
                curveTo(24.212f, 7.818f, 24.211f, 7.778f, 24.211f, 7.75f)
                curveTo(24.21f, 7.737f, 24.21f, 7.726f, 24.21f, 7.718f)
                curveTo(24.21f, 7.714f, 24.209f, 7.711f, 24.209f, 7.709f)
                curveTo(24.209f, 7.708f, 24.209f, 7.708f, 24.209f, 7.707f)
                curveTo(24.209f, 7.707f, 24.209f, 7.707f, 24.209f, 7.707f)
                curveTo(24.209f, 7.706f, 24.209f, 7.706f, 24.209f, 7.706f)
                curveTo(24.209f, 7.706f, 24.209f, 7.706f, 24.209f, 7.706f)
                curveTo(24.209f, 7.706f, 24.209f, 7.706f, 24.084f, 7.71f)
                close()
                moveTo(24.547f, 8.592f)
                curveTo(24.547f, 8.504f, 24.521f, 8.4f, 24.488f, 8.302f)
                curveTo(24.455f, 8.202f, 24.41f, 8.095f, 24.367f, 8f)
                curveTo(24.324f, 7.904f, 24.281f, 7.817f, 24.248f, 7.754f)
                curveTo(24.232f, 7.722f, 24.219f, 7.696f, 24.209f, 7.678f)
                curveTo(24.205f, 7.669f, 24.201f, 7.662f, 24.198f, 7.658f)
                curveTo(24.197f, 7.655f, 24.196f, 7.653f, 24.195f, 7.652f)
                curveTo(24.195f, 7.651f, 24.194f, 7.651f, 24.194f, 7.651f)
                curveTo(24.194f, 7.65f, 24.194f, 7.65f, 24.194f, 7.65f)
                curveTo(24.194f, 7.65f, 24.194f, 7.65f, 24.194f, 7.65f)
                curveTo(24.194f, 7.65f, 24.194f, 7.65f, 24.194f, 7.65f)
                curveTo(24.194f, 7.65f, 24.194f, 7.65f, 24.084f, 7.71f)
                curveTo(23.975f, 7.77f, 23.975f, 7.77f, 23.975f, 7.77f)
                curveTo(23.975f, 7.77f, 23.975f, 7.77f, 23.975f, 7.77f)
                curveTo(23.975f, 7.77f, 23.975f, 7.77f, 23.975f, 7.77f)
                curveTo(23.975f, 7.77f, 23.975f, 7.771f, 23.975f, 7.771f)
                curveTo(23.975f, 7.771f, 23.975f, 7.771f, 23.976f, 7.772f)
                curveTo(23.976f, 7.773f, 23.977f, 7.774f, 23.978f, 7.777f)
                curveTo(23.981f, 7.781f, 23.984f, 7.787f, 23.989f, 7.796f)
                curveTo(23.997f, 7.813f, 24.01f, 7.837f, 24.026f, 7.867f)
                curveTo(24.057f, 7.928f, 24.098f, 8.011f, 24.139f, 8.103f)
                curveTo(24.181f, 8.194f, 24.221f, 8.292f, 24.251f, 8.381f)
                curveTo(24.282f, 8.474f, 24.297f, 8.546f, 24.297f, 8.592f)
                horizontalLineTo(24.547f)
                close()
                moveTo(24.54f, 8.773f)
                curveTo(24.539f, 8.769f, 24.54f, 8.764f, 24.542f, 8.73f)
                curveTo(24.545f, 8.699f, 24.547f, 8.656f, 24.547f, 8.592f)
                horizontalLineTo(24.297f)
                curveTo(24.297f, 8.648f, 24.295f, 8.684f, 24.293f, 8.711f)
                curveTo(24.291f, 8.733f, 24.288f, 8.765f, 24.291f, 8.795f)
                lineTo(24.54f, 8.773f)
                close()
                moveTo(24.638f, 8.997f)
                curveTo(24.595f, 8.903f, 24.571f, 8.851f, 24.555f, 8.814f)
                curveTo(24.547f, 8.796f, 24.544f, 8.786f, 24.541f, 8.78f)
                curveTo(24.54f, 8.775f, 24.54f, 8.773f, 24.54f, 8.773f)
                lineTo(24.291f, 8.795f)
                curveTo(24.294f, 8.837f, 24.308f, 8.873f, 24.325f, 8.913f)
                curveTo(24.342f, 8.952f, 24.37f, 9.012f, 24.41f, 9.1f)
                lineTo(24.638f, 8.997f)
                close()
                moveTo(24.358f, 9.277f)
                curveTo(24.394f, 9.29f, 24.432f, 9.304f, 24.463f, 9.312f)
                curveTo(24.479f, 9.316f, 24.499f, 9.321f, 24.52f, 9.322f)
                curveTo(24.539f, 9.323f, 24.573f, 9.323f, 24.607f, 9.306f)
                curveTo(24.647f, 9.285f, 24.672f, 9.249f, 24.682f, 9.211f)
                curveTo(24.691f, 9.179f, 24.687f, 9.15f, 24.684f, 9.13f)
                curveTo(24.677f, 9.09f, 24.659f, 9.045f, 24.638f, 8.997f)
                lineTo(24.41f, 9.1f)
                curveTo(24.419f, 9.121f, 24.426f, 9.138f, 24.431f, 9.151f)
                curveTo(24.436f, 9.165f, 24.437f, 9.172f, 24.438f, 9.174f)
                curveTo(24.438f, 9.178f, 24.435f, 9.166f, 24.44f, 9.148f)
                curveTo(24.443f, 9.138f, 24.448f, 9.125f, 24.458f, 9.112f)
                curveTo(24.468f, 9.099f, 24.481f, 9.089f, 24.493f, 9.083f)
                curveTo(24.516f, 9.071f, 24.535f, 9.073f, 24.536f, 9.073f)
                curveTo(24.539f, 9.073f, 24.537f, 9.073f, 24.528f, 9.071f)
                curveTo(24.509f, 9.066f, 24.484f, 9.056f, 24.444f, 9.042f)
                lineTo(24.358f, 9.277f)
                close()
                moveTo(23.875f, 9.174f)
                curveTo(24.073f, 9.174f, 24.237f, 9.233f, 24.358f, 9.277f)
                lineTo(24.444f, 9.042f)
                curveTo(24.323f, 8.998f, 24.121f, 8.924f, 23.875f, 8.924f)
                verticalLineTo(9.174f)
                close()
                moveTo(24.001f, 8.589f)
                curveTo(23.963f, 8.589f, 23.925f, 8.601f, 23.898f, 8.611f)
                curveTo(23.867f, 8.623f, 23.834f, 8.639f, 23.802f, 8.657f)
                curveTo(23.739f, 8.692f, 23.669f, 8.741f, 23.618f, 8.795f)
                curveTo(23.593f, 8.821f, 23.565f, 8.856f, 23.549f, 8.898f)
                curveTo(23.532f, 8.942f, 23.525f, 9.005f, 23.564f, 9.065f)
                curveTo(23.598f, 9.118f, 23.653f, 9.142f, 23.7f, 9.155f)
                curveTo(23.748f, 9.168f, 23.807f, 9.174f, 23.875f, 9.174f)
                verticalLineTo(8.924f)
                curveTo(23.818f, 8.924f, 23.784f, 8.919f, 23.766f, 8.914f)
                curveTo(23.745f, 8.908f, 23.759f, 8.907f, 23.773f, 8.928f)
                curveTo(23.791f, 8.956f, 23.784f, 8.983f, 23.782f, 8.988f)
                curveTo(23.782f, 8.99f, 23.784f, 8.983f, 23.799f, 8.967f)
                curveTo(23.827f, 8.937f, 23.875f, 8.903f, 23.924f, 8.875f)
                curveTo(23.948f, 8.862f, 23.97f, 8.851f, 23.987f, 8.845f)
                curveTo(24.008f, 8.837f, 24.011f, 8.839f, 24.001f, 8.839f)
                verticalLineTo(8.589f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun ZambiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Zambia,
            contentDescription = "Zambia Flag"
        )
    }
}
